<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" :tip="loadTip">
      <a-form :form="visit.form" layout="horizontal">
        <a-card :bordered="false" size="small" :head-style="{'borderBottom':'none'}" :body-style="{'padding':'0px', 'width':'calc(100% - 120px)'}">
        <span slot="title" style="font-size: 18px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #000000;">
          <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>患者信息
        </span>
          <a-row>
            <a-col style="margin-left: 60px;">
              <a-form-item :colon="false" class="gpws-m-b-10">
                <a-radio-group v-model="visit.visitType">
                  <a-radio value="INITIAL_VISIT"><label :style="visit.visitType == 'INITIAL_VISIT'?'color: #1890ff;':''">初诊患者</label></a-radio>
                  <a-radio value="SUBSEQUENT_VISIT"><label :style="visit.visitType == 'SUBSEQUENT_VISIT'?'color: #1890ff;':''">复诊患者</label></a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="姓名" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-input v-decorator="['name', { rules: [{ required: true, message: '就诊人姓名必须填写!' }] , initialValue: record.name}]" placeholder="请填写就诊人姓名">
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="身份证号" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-input v-decorator="['idcard', { rules: [{ required: false, message: '就诊人身份证号必须填写!' },{ pattern: '((^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$)|(^\\d{6}(18|19|20)?\\d{2}(0[1-9]|1[012])(0[1-9]|[12]\\d|3[01])\\d{3}(\\d|[xX])$))',
          message: '就诊人身份证号格式错误'}] , initialValue: (record.idcard||'') }]" placeholder="请填写就诊人身份证号" @blur="onBlurIdcard"/>
              </a-form-item>
            </a-col>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="年龄" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }" style="white-space: nowrap;">
                <a-input-number :min="0" :step="1" :max="120" v-decorator="['year', { rules: [{ required: true, message: '就诊人年龄必须填写!' }] , initialValue: record.year }]" placeholder="请填写就诊人年龄" style="width: 80px;min-width: 60px;" @change="gestateAgeChange"/>岁
                <a-input-number :min="0" :step="1" :max="11" v-model="record.month" placeholder="请填写就诊人年龄" style="width: 80px;min-width: 60px;" @change="gestateAgeMonthChange"/>个月
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="电话号码" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-input v-decorator="['phone', { rules: [{ required: true, message: '就诊人电话号码必须填写!' },{pattern: '^\\d{3,4}[-]\\d{8}$|^[1]([3-9])[0-9]{9}$', message: '就诊人电话号码(手机号码/座机号)格式错误,座机格式:XXXX[XXX]-XXXXXXXX'}] , initialValue: record.phone }]" placeholder="请填写就诊人电话号码"/>
              </a-form-item>
            </a-col>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="性别" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-select v-decorator="['sex', {rules: [{ required: true, message: '就诊人性别必须选择!' }], initialValue: record.sex }]" placeholder="请选择就诊人性别" @change="gestateSexChange">
                  <a-select-option value="MALE">男</a-select-option>
                  <a-select-option value="FEMALE">女</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="孕否" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-select :disabled="!visit.gestate" v-decorator="['gestate', {rules: [{ required: visit.gestate, message: '就诊人是否怀孕必须选择!' }], initialValue: ((record.gestate||false) === true ?'true':'false') }]" placeholder="请选择就诊人是否怀孕" @change="gestateChangeAction">
                  <a-select-option value="true">孕</a-select-option>
                  <a-select-option value="false">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="体温" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-input-number :min="28" :max="42" :step="0.1" v-decorator="['temperature', {rules: [{ required: false }], initialValue: (record.temperature||'') }]" placeholder="请输入患者体温"/>℃
              </a-form-item>
            </a-col>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="血糖" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-input-number :min="1" :max="34" :step="0.1" v-decorator="['glu', {rules: [{ required: false }], initialValue: (record.glu||'') }]" placeholder="请输入患者血糖"/>mmol/L
              </a-form-item>
            </a-col>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="血压" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }" style="white-space: nowrap;">
                <a-input-number :min="30" :step="1" :max="280" v-model="record.sbp" placeholder="收缩压" style="width: 80px;min-width: 60px;"/>mmHg/
                <a-input-number :min="20" :step="1" :max="200" v-model="record.dbp" placeholder="舒张压" style="width: 80px;min-width: 60px;"/>mmHg
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
              <a-form-item :colon="false" label="主诉" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 2, xl: 2, xxl: 2 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
                <a-input v-decorator="['complaint', {rules: [{ required: false }], initialValue: (record.complaint||'') }]" placeholder="请输入患者主诉"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="临床诊断" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-select mode="multiple" :disabled="(diseased != undefined && !diseased)" v-decorator="['diseases', {rules: [{ required: false, message: '临床诊断必须填写!' }], initialValue: (record.diseases||undefined) }]" show-search :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" @focus="handleDiseaseFocus" @deselect="handleDiseaseCancel" @select="handleDiseaseSelect" @search="(value) => handleDiseaseSearch(value)" placeholder="请输入疾病名称检索">
                  <a-select-option v-for="item in init.diseases" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="中医主症" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-select show-search :disabled="(diseased != undefined && diseased)" v-decorator="['symptom', {rules: [{ required: false, message: '中医主症必须填写!' }], initialValue: (record.symptom||undefined) }]" placeholder="请输入中医主症后进行选择" :dropdown-style="{'width': '600px'}" option-label-prop="label" :dropdown-match-select-width="false" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" @select="mainSymptomSelect" @search="mainSymptomSearch">
                  <a-select-option value="" label="">选择中医主症</a-select-option>
                  <a-select-option v-for="item in init.symptoms" :key="item.id" :value="item.id" :label="item.name">
                    <a-row>
                      <a-col span="8" style="color:rgba(44, 158, 21, 1);font-weight: 400;">
                        {{ item.name }}
                      </a-col>
                      <a-col span="16" style="white-space:pre-wrap;word-wrap:break-word;overflow:hidden;">
                        <template v-if="(undefined != item.alias && null != item.alias && item.alias.length > 0)">
                          <template v-for="e in item.alias">
                            &nbsp;{{ e }}
                          </template>
                        </template>
                        &nbsp;{{ item.initial }} &nbsp; {{ item.full }}
                      </a-col>
                    </a-row>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xxl="8" :xl="8" :lg="8" :md="12" :sm="12" :xs="24">
              <a-form-item :colon="false" label="中医辨证" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 13, xl: 13, xxl: 13 }">
                <a-select mode="tags" v-decorator="['syndromes', {rules: [{ required: false, message: '中医辨证必须填写!' }], initialValue: (record.syndromes||undefined) }]" placeholder="请填写中医辨证">
                  <a-select-option v-for="(e , i) in init.syndromes" :value="e" :key="'s-'+(i+1)">{{ e }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xxl="12" :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
              <a-form-item :colon="false" label="过敏史" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                <a-input v-decorator="['allergyHistory', {rules: [{ required: false }], initialValue: (record.allergy||'') }]" placeholder="请输入患者过敏史"/>
              </a-form-item>
            </a-col>
            <a-col :xxl="12" :xl="12" :lg="12" :md="24" :sm="24" :xs="24">
              <a-form-item :colon="false" label="治疗建议" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                <a-input v-decorator="['suggest', {rules: [{ required: false }], initialValue: (record.suggest||'') }]" placeholder="请输入治疗建议"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
        <a-card :bordered="false" size="small" :head-style="{'borderBottom':'none'}" :body-style="{'padding':'0px', 'width':'calc(100% - 120px)'}">
        <span slot="title" style="font-size: 18px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #000000;">
          <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>处理
        </span>
          <a-row>
            <a-col span="12" style="padding-left: 30px;margin-bottom: 4px;">
              <a-button-group shape="round">
                <a-button size="default" :class="(visit.recipeType == 'CM'?'gpws-recipe-left-active':'gpws-recipe-left-btn')" @click="recipeChange('CM')">中药处方</a-button>
                <a-button size="default" :class="(visit.recipeType =='DISPOSE'?'gpws-recipe-active':'gpws-recipe-btn')" @click="recipeChange('DISPOSE')">中医处置</a-button>
                <a-button size="default" :class="(visit.recipeType =='CPM'?'gpws-recipe-active':'gpws-recipe-btn')" @click="recipeChange('CPM')">中成药处方</a-button>
                <a-button size="default" :class="(visit.recipeType =='WM'?'gpws-recipe-right-active':'gpws-recipe-right-btn')" @click="recipeChange('WM')">西药处方</a-button>
              </a-button-group>
            </a-col>
            <a-col span="12" style="padding-right: 30px;">
              <a-button type="primary" style="float: right;" ghost v-if="visit.recipeType == 'DISPOSE'" @click="appendDispose">添加处置</a-button>
              <a-button type="primary" style="float: right;" ghost v-if="((visit.recipeType == 'CPM')||(visit.recipeType == 'WM'))" @click="appendRecipeDrug">添加药品</a-button>
            </a-col>
          </a-row>
          <a-row>
            <a-col>
              <a-card :bordered="false" size="small" :style="{'paddingLeft':'30px','paddingRight':'30px','display':(visit.recipeType == 'CM'?'block':'none')}" :head-style="{'borderBottom':'none'}" :body-style="{'padding':'0px'}">
                <a-row style="background:rgba(99, 171, 205, 0.06);border: 1px solid #e4e7ea;border-top-right-radius: 4px;border-top-left-radius: 4px;">
                  <a-col :xxl="16" :xl="16" :lg="16" :md="24" :sm="24" :xs="24">
                    <span style="height:40px;line-height:40px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #127dac!important;margin-left: 17px;">中药处方</span>
                  </a-col>
                  <a-col :xxl="4" :xl="4" :lg="4" :md="12" :sm="12" :xs="24" style="line-height:36px!important;">
                    <a-form-item :colon="false" label="剂型切换" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                      <a-select :disabled="(converted === false)" v-model="visit.formType" @change="formTypeChange">
                        <a-select-option v-for="e in init.formTypes" :key="e.id" :value="e.id">{{ e.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :xxl="4" :xl="4" :lg="4" :md="12" :sm="12" :xs="24">
                    <a-form-item :colon="false" label="加工方式" class="gpws-m-b-0" style="line-height:36px!important;" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                      <a-select v-model="visit.handle" @change="handleChangeAction">
                        <template v-for="e in init.handles">
                          <a-select-option v-if="visit.formType == e.type" :key="e.id" :value="e.id">{{ e.name }}</a-select-option>
                        </template>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-table :columns="column.cm" :data-source="visit.cmrecipes" row-key="id" size="small" :scroll="{ y: 200 }" :pagination="false" class="gpws-recipe-table" :customRow="checkCustomRow">
                  <span slot="cmindex" slot-scope="text, record, index">
                    {{ (index + 1) }}
                  </span>
                  <span slot="cmdrug" slot-scope="text, record, index">
                  <a-select placeholder="请输入药品名称检索" v-model="record.id" option-label-prop="label" @focus="autoCompleteDrugFocus(record.id, index, 'CM')" @search="value => autoCompleteDrugSearch(value, record.id, index, 'CM')" @select="value => autoCompleteDrugSelect(value, index, 'CM')" style="width: 180px;" allowClear show-search :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" :dropdown-match-select-width="false" :dropdown-style="{'width': '400px'}">
                    <template v-if="(record.drugs||[]).length > 0">
                        <a-select-option v-for="item in (record.drugs||[])" :key="'cm-'+(index + 1)+'-'+item.id" :label="item.name" :value="item.id">
                          <a-row>
                            <a-col span="8">
                              <template v-if="(undefined != item.alias && null != item.alias && item.alias.length > 0)">
                                  <a-tooltip placement="topRight" :color="'blue'">
                                    <template #title>
                                      <span>{{ item.alias.join('/') }}</span>
                                    </template>
                                    {{ item.name }}
                                  </a-tooltip>
                                </template>
                                <template v-else>
                                  {{ item.name }}
                                </template>
                            </a-col>
                            <a-col span="4">
                              {{ item.formName }}
                            </a-col>
                            <a-col span="12">
                              {{ item.supplier }}
                            </a-col>
                          </a-row>
                        </a-select-option>
                      </template>
                      <template v-else>
                        <template v-if="(drugs||[]).length > 0">
                          <a-select-option v-for="item in drugs" :key="'cm-'+(index + 1)+'-'+item.id" :label="item.name" :value="item.id">
                            <a-row>
                              <a-col span="8">
                                <template v-if="(undefined != item.alias && null != item.alias && item.alias.length > 0)">
                                  <a-tooltip placement="topRight" :color="'blue'">
                                    <template #title>
                                      <span>{{ item.alias.join('/') }}</span>
                                    </template>
                                    {{ item.name }}
                                  </a-tooltip>
                                </template>
                                <template v-else>
                                  {{ item.name }}
                                </template>
                              </a-col>
                              <a-col span="4">
                                {{ item.formName }}
                              </a-col>
                              <a-col span="12">
                                {{ item.supplier }}
                              </a-col>
                            </a-row>
                          </a-select-option>
                        </template>
                      </template>
                  </a-select>
                  </span>
                  <span slot="cmform" slot-scope="text, record, index">
                  {{ record.formName }}
                </span>
                <span slot="cmdosage" slot-scope="text, record, index">
                  <a-input-number :min="0" :step="(record.form ==='GRANULE'?1:0.1)" v-model="record.dosage" placeholder="请输入用量" @change="value => cmDrugDosesChange(value, record.id, index)"/>
                </span>
                <span slot="cmweight" slot-scope="text, record, index">
                  {{ (record.weight||'') }}{{ (record.piecesUnit||'') }}
                </span>
                <span slot="cmunit" slot-scope="text, record, index">
                  <a-select v-model="record.unit" style="width: 100px;">
                    <a-select-option v-for="(item, i) in record.units" :key="'d-'+record.id+'-'+(i+1)" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </span>
                <span slot="cmrecommend" slot-scope="text, record, index">
                  {{ record.recommend }}
                </span>
                  <span slot="cmusage" slot-scope="text, record, index">
                  <a-input placeholder="请输入备注" v-model="record.usage" style="min-width:250px;width: 100%;"/>
                </span>
                  <span slot="cmoperate" slot-scope="text, record, index">
                  <a href="javascript:;" @click="()=>deleteDrugs(record.id, index, 'CM')">删除</a>
                </span>
                </a-table>
                <a-row v-if="init.presaged" style="background:rgba(40, 228, 67, 0.06); height: 36px;">
                  <a-col style="text-align: center;">
                    <span style="height:36px;line-height:36px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #127dac!important;left: 17px;position: absolute;">处方说明</span>
                    <span v-if="init.presopened" style="height:36px;line-height:36px;font-size: 14px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #127dac;cursor: pointer;" @click="presOpenAction(false)">收起&nbsp;<a-icon type="double-left" :rotate="90" style="color: #127dac;"/></span>
                    <span v-else style="height:36px;line-height:36px;font-size: 14px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #127dac;cursor: pointer;" @click="presOpenAction(true)">展开&nbsp;<a-icon type="double-right" :rotate="90" style="color: #127dac;"/></span>
                  </a-col>
                </a-row>
                <a-row v-if="init.presopened">
                  <a-col style="border: 1px solid rgba(232, 232, 232, 1);">
                    <a-row>
                      <a-col span="24" style="padding-left: 30px;padding-top: 4px;padding-bottom: 4px;border-bottom: 1px solid rgba(232, 232, 232, 1);">
                        <a-button-group shape="round">
                          <a-button size="small" :class="(init.descType =='A'?'gpws-desc-left-active':'gpws-desc-left-btn')" @click="descTypeChange('A')">补充说明</a-button>
                          <a-button size="small" :class="(init.descType =='B'?'gpws-desc-active':'gpws-desc-btn')" @click="descTypeChange('B')">合理用药</a-button>
                          <a-button size="small" :class="(init.descType =='C'?'gpws-desc-active':'gpws-desc-btn')" @click="descTypeChange('C')">疾病说明</a-button>
                          <a-button size="small" :class="(init.descType =='D'?'gpws-desc-right-active':'gpws-desc-right-btn')" @click="descTypeChange('D')">解读赏析</a-button>
                        </a-button-group>
                      </a-col>
                    </a-row>
                    <a-row v-if="init.descType =='A'">
                      <a-col span="24" style="height: 120px;overflow-y: auto;">
                        <template v-for="(item, index) in complements">
                          <a-row>
                            <a-col span="1" style="line-height: 26px;text-align: right;">{{ (index+1) }}.</a-col>
                            <a-col span="23" style="line-height: 26px;">
                              <span v-html="parseRecipe(item.drugs, item.desc)"/>&nbsp;&nbsp;<a-button v-if="(item.drugs||[]).length > 0" shape="circle" size="small" icon="plus-circle" style="cursor: pointer;" title="添加至处方." :disabled="item.used" @click="appendComplement(index)"/>
                            </a-col>
                          </a-row>
                        </template>
                      </a-col>
                    </a-row>
                    <a-row v-if="init.descType =='B'">
                      <a-col span="24" style="height: 120px;overflow-y: auto;">
                        <template v-for="(item, index) in visit.cmrecipes.filter(m => m.errored).filter(m => m.msgs.length > 0)">
                          <a-row>
                            <a-col span="1" style="line-height: 26px;text-align: right;">{{ (index+1) }}.</a-col>
                            <a-col span="23" style="line-height: 26px;color: #d02f2f;">
                              药品[{{ item.name }}]&nbsp;{{ item.msgs.map(n => n.msg).join(';') }}
                            </a-col>
                          </a-row>
                        </template>
                        <template v-for="(item, index) in init.replaceables">
                          <a-row>
                            <a-col span="1" style="line-height: 26px;text-align: right;">{{ ((visit.cmrecipes.filter(m => m.errored).length) + index + 1) }}.</a-col>
                            <a-col span="23" style="line-height: 26px;">
                              药品[{{ item.name }}]&nbsp;可替换为:{{ item.replaceable }}
                            </a-col>
                          </a-row>
                        </template>
                        <template v-if="!converted">
                          <a-row>
                            <a-col span="1" style="line-height: 26px;text-align: right;">{{ ((visit.cmrecipes.filter(m => m.errored).length) + ((init.replaceables||[]).length) + 1) }}.</a-col>
                            <a-col span="23" style="line-height: 26px;">
                              处方中不可进行剂型切换的药品:{{(visit.cmrecipes||[]).filter(m => (undefined != m.name && null != m.name && '' != m.name)).filter(m => (m.insteads||[]).length <= 0).map(n=>n.name).join(',')}}
                            </a-col>
                          </a-row>
                        </template>
                      </a-col>
                    </a-row>
                    <a-row v-if="init.descType =='C'">
                      <a-col span="24" style="height: 120px;overflow-y: auto;">
                        &nbsp;&nbsp;&nbsp;{{ init.pres.experience }}
                      </a-col>
                    </a-row>
                    <a-row v-if="init.descType =='D'">
                      <a-col span="23" style="height: 120px;overflow-y: auto;">
                        &nbsp;&nbsp;&nbsp;{{ init.pres.appreciate }}
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :xxl="4" :xl="4" :lg="4" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 9, xl: 9, xxl: 9 }" :wrapper-col="{sm: 24, md: 12, lg: 15, xl: 15, xxl: 15 }">
                      <span slot="label" style="font-size: 16px;font-weight: bold;">付数</span>
                      <a-input-number :min="1" :max="30" :step="1" v-decorator="['doses', {rules: [{ required: true, message:'中药付数不可为空.' }], initialValue: 1 }]" placeholder="请输入中药付数"/>
                    </a-form-item>
                  </a-col>
                  <a-col :xxl="6" :xl="6" :lg="6" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" label="处方流转" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      <a-select v-decorator="['cmroam', {rules: [{ required: true, message:'请选择处方流转去向.' }], initialValue: 'LOCAL' }]" @change="(value)=>onRoamChange(value, 'CM')">
                        <a-select-option v-for="e in init.roams" :key="e.id" :value="e.id">{{ e.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :xxl="14" :xl="14" :lg="14" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" label="服用方法" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
                      <a-input v-decorator="['cmusage', {rules: [{ required: false }], initialValue: '' }]" placeholder="请输入服用方法">
                        <a-button type="link" size="small" slot="addonAfter" @click="medicalSelectAction">选择</a-button>
                      </a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" label="医嘱" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 1, xl: 1, xxl: 1 }" :wrapper-col="{sm: 24, md: 12, lg: 23, xl: 23, xxl: 23 }">
                      <a-textarea v-decorator="['cmadvice', {rules: [{ required: false }], initialValue: '' }]" placeholder="请输入医嘱"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-card>
              <a-card :bordered="false" size="small" :style="{'paddingLeft':'30px','paddingRight':'30px','display':(visit.recipeType == 'DISPOSE'?'block':'none')}" :head-style="{'borderBottom':'none'}" :body-style="{'padding':'0px'}">
                <a-row style="background:rgba(99, 171, 205, 0.06);border: 1px solid #e4e7ea;border-top-right-radius: 4px;border-top-left-radius: 4px;">
                  <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <span style="height:40px;line-height:40px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #127dac!important;margin-left: 17px;">中医处置</span>
                  </a-col>
                </a-row>
                <a-table :columns="column.dispose" :data-source="visit.disposes" row-key="id" size="small" :scroll="{ y: 300 }" :pagination="false" style="min-height: 348px!important;" class="gpws-recipe-table">
                <span slot="dpindex" slot-scope="text, record, index">
                  {{ (index + 1) }}
                </span>
                  <span slot="dpname" slot-scope="text, record, index">
                  <a-select placeholder="请输入中医处置名称检索" v-model="record.id" style="width: 180px;" @select="value => autoCompleteDisposeSelect(value, index)">
                    <a-select-option v-for="item in init.disposes" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                  </a-select>
                </span>
                  <span slot="dpquantity" slot-scope="text, record, index">
                  <a-input-number :min="1" :step="1" v-model="record.quantity" placeholder="请输入次数"/>
                </span>
                  <span slot="dpunit" slot-scope="text, record, index">
                  {{ record.unit }}
                </span>
                  <span slot="dpoperator" slot-scope="text, record, index">
                  <a-select v-model="record.operator" style="width: 150px;">
                    <a-select-opt-group v-for="(item, i) in init.doctors" :key="'d-'+(index+1)+'-'+(i+1)" :label="item.name">
                      <a-select-option  v-for="(e, n) in item.children" :key="'d-e-'+(index+1)+'-'+(n+1)" :value="e.id">{{ e.name }}</a-select-option>
                    </a-select-opt-group>
                  </a-select>
                </span>
                  <span slot="dpusage" slot-scope="text, record, index">
                  <a-input placeholder="请输入备注" v-model="record.describe"/>
                </span>
                  <span slot="dpoperate" slot-scope="text, record, index">
                  <a href="javascript:;" @click="()=>deleteDispose(index)">删除</a>
                </span>
                </a-table>
              </a-card>
              <a-card :bordered="false" size="small" :style="{'paddingLeft':'30px','paddingRight':'30px','display':(visit.recipeType == 'CPM'?'block':'none')}" :head-style="{'borderBottom':'none'}" :body-style="{'padding':'0px'}">
                <a-row style="background:rgba(99, 171, 205, 0.06);border: 1px solid #e4e7ea;border-top-right-radius: 4px;border-top-left-radius: 4px;">
                  <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <span style="height:40px;line-height:40px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #127dac!important;margin-left: 17px;">中成药处方</span>
                  </a-col>
                </a-row>
                <a-table :columns="column.cpm" :data-source="visit.cpmrecipes" row-key="id" size="small" :scroll="{ y: 200 }" :pagination="false" class="gpws-recipe-table">
                <span slot="cpmindex" slot-scope="text, record, index">
                  {{ (index + 1) }}
                </span>
                  <span slot="cpmdrug" slot-scope="text, record, index">
                  <a-select placeholder="请输入药品名称检索" v-model="record.id" option-label-prop="label" @search="value => autoCompleteDrugSearch(value, record.id, index, 'CPM')" @select="value => autoCompleteDrugSelect(value, index, 'CPM')" style="width: 140px;" allowClear show-search :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" :dropdown-match-select-width="false" :dropdown-style="{'width': '400px'}">
                    <template slot="dataSource">
                      <a-select-option v-for="item in drugs" :key="'cpm-'+(index + 1)+'-'+item.id" :label="item.name" :value="item.id">
                        <a-row>
                          <a-col span="8">
                            {{ item.name }}
                          </a-col>
                          <a-col span="4">
                            {{ item.formName }}
                          </a-col>
                          <a-col span="12">
                            {{ item.supplier }}
                          </a-col>
                        </a-row>
                      </a-select-option>
                    </template>
                  </a-select>
                </span>
                  <span slot="cpmspec" slot-scope="text, record, index">
                  {{ record.formName }} {{ record.spec }}
                </span>
                  <span slot="cpmdosage" slot-scope="text, record, index" style="white-space: nowrap;">
                  <a-input-number :min="0" :step="0.1" v-model="record.dosage" placeholder="请输入用量" style="width: 80px;"/>
                  <a-select v-model="record.unit" style="width: 80px;">
                    <a-select-option v-for="(item, i) in record.units" :key="'d-'+record.id+'-'+(i+1)" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </span>
                  <span slot="cpmfrequency" slot-scope="text, record, index">
                  <a-select v-model="record.frequency" style="width: 110px;">
                    <a-select-option v-for="(item, i) in init.frequencies" :key="'d-'+record.code+'-'+(i+1)" :value="item.code">
                      {{ item.desc }}
                    </a-select-option>
                  </a-select>
                </span>
                  <span slot="cpmqty" slot-scope="text, record, index" style="white-space: nowrap;">
                  <a-input-number :min="0" :step="0.1" v-model="record.saleQty" placeholder="请输入总量" style="width: 80px;"/>
                  <a-select v-model="record.saleUnit" style="width: 80px;">
                    <a-select-option v-for="(item, i) in record.saleUnits" :key="'d-'+record.id+'-'+(i+1)" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </span>
                  <span slot="cpmoperate" slot-scope="text, record, index">
                  <a href="javascript:;" @click="()=>deleteDrugs(record.id, index, 'CPM')">删除</a>
                </span>
                </a-table>
                <a-row>
                  <a-col :xxl="4" :xl="4" :lg="4" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                      <span slot="label" style="font-size: 16px;font-weight: bold;">用药天数</span>
                      <a-input-number :min="1" :step="1" v-decorator="['cpmdays', {rules: [{ required: true, message:'用药天数不可为空.' }], initialValue: 1 }]" placeholder="请输入用药天数"/>
                    </a-form-item>
                  </a-col>
                  <a-col :xxl="6" :xl="6" :lg="6" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" label="处方流转" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      <a-select v-decorator="['cpmroam', {rules: [{ required: true, message:'请选择处方流转去向.' }], initialValue: 'LOCAL' }]" @change="(value)=>onRoamChange(value, 'CPM')">
                        <a-select-option v-for="e in init.roams" :key="e.id" :value="e.id">{{ e.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :xxl="14" :xl="14" :lg="14" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" label="服用方法" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
                      <a-input v-decorator="['cpmusage', {rules: [{ required: false }], initialValue: '' }]" placeholder="请输入服用方法"/>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" label="医嘱" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 1, xl: 1, xxl: 1 }" :wrapper-col="{sm: 24, md: 12, lg: 23, xl: 23, xxl: 23 }">
                      <a-textarea v-decorator="['cpmadvice', {rules: [{ required: false }], initialValue: '' }]" placeholder="请输入医嘱"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-card>
              <a-card :bordered="false" size="small" :style="{'paddingLeft':'30px','paddingRight':'30px','display':(visit.recipeType == 'WM'?'block':'none')}" :head-style="{'borderBottom':'none'}" :body-style="{'padding':'0px'}">
                <a-row style="background:rgba(99, 171, 205, 0.06);border: 1px solid #e4e7ea;border-top-right-radius: 4px;border-top-left-radius: 4px;">
                  <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <span style="height:40px;line-height:40px;font-size: 16px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #127dac!important;margin-left: 17px;">西药处方</span>
                  </a-col>
                </a-row>
                <a-table :columns="column.wm" :data-source="visit.wmrecipes" row-key="id" size="small" :scroll="{ y: 200 }" :pagination="false" class="gpws-recipe-table">
                <span slot="wmindex" slot-scope="text, record, index">
                  {{ (index + 1) }}
                </span>
                  <span slot="wmdrug" slot-scope="text, record, index">
                  <a-select placeholder="请输入药品名称检索" v-model="record.id" option-label-prop="label" @search="value => autoCompleteDrugSearch(value, record.id, index, 'WM')" @select="value => autoCompleteDrugSelect(value, index, 'WM')" style="width: 140px;" allowClear show-search :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" :dropdown-match-select-width="false" :dropdown-style="{'width': '400px'}">
                    <template slot="dataSource">
                      <a-select-option v-for="item in drugs" :key="'wm-'+(index + 1)+'-'+item.id" :label="item.name" :value="item.id">
                        <a-row>
                          <a-col span="8">
                            {{ item.name }}
                          </a-col>
                          <a-col span="4">
                            {{ item.formName }}
                          </a-col>
                          <a-col span="12">
                            {{ item.supplier }}
                          </a-col>
                        </a-row>
                      </a-select-option>
                    </template>
                  </a-select>
                </span>
                  <span slot="wmspec" slot-scope="text, record, index">
                  {{ record.formName }} {{ record.spec }}
                </span>
                  <span slot="wmdosage" slot-scope="text, record, index" style="white-space: nowrap;">
                  <a-input-number :min="0" :step="0.1" v-model="record.dosage" placeholder="请输入用量" style="width: 80px;"/>
                  <a-select v-model="record.unit" style="width: 80px;">
                    <a-select-option v-for="(item, i) in record.units" :key="'d-'+record.id+'-'+(i+1)" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </span>
                  <span slot="wmfrequency" slot-scope="text, record, index">
                  <a-select v-model="record.frequency" style="width: 110px;">
                    <a-select-option v-for="(item, i) in init.frequencies" :key="'d-'+record.code+'-'+(i+1)" :value="item.code">
                     {{ item.desc }}
                    </a-select-option>
                  </a-select>
                </span>
                  <span slot="wmqty" slot-scope="text, record, index" style="white-space: nowrap;">
                  <a-input-number :min="0" :step="0.1" v-model="record.saleQty" placeholder="请输入总量" style="width: 80px;"/>
                  <a-select v-model="record.saleUnit" style="width: 80px;">
                    <a-select-option v-for="(item, i) in record.saleUnits" :key="'d-'+record.id+'-'+(i+1)" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </span>
                  <span slot="wmoperate" slot-scope="text, record, index">
                  <a href="javascript:;" @click="()=>deleteDrugs(record.id, index, 'WM')">删除</a>
                </span>
                </a-table>
                <a-row>
                  <a-col :xxl="4" :xl="4" :lg="4" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                      <span slot="label" style="font-size: 16px;font-weight: bold;">用药天数</span>
                      <a-input-number :min="1" :step="1" v-decorator="['wmdays', {rules: [{ required: true, message:'用药天数不可为空.' }], initialValue: 1 }]" placeholder="请输入用药天数"/>
                    </a-form-item>
                  </a-col>
                  <a-col :xxl="6" :xl="6" :lg="6" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" label="处方流转" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                      <a-select v-decorator="['wmroam', {rules: [{ required: true, message:'请选择处方流转去向.' }], initialValue: 'LOCAL' }]" @change="(value)=>onRoamChange(value, 'WM')">
                        <a-select-option v-for="e in init.roams" :key="e.id" :value="e.id">{{ e.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :xxl="14" :xl="14" :lg="14" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" label="服用方法" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 20, xl: 20, xxl: 20 }">
                      <a-input v-decorator="['wmusage', {rules: [{ required: false }], initialValue: '' }]" placeholder="请输入服用方法"/>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :xxl="24" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                    <a-form-item :colon="false" label="医嘱" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 1, xl: 1, xxl: 1 }" :wrapper-col="{sm: 24, md: 12, lg: 23, xl: 23, xxl: 23 }">
                      <a-textarea v-decorator="['wmadvice', {rules: [{ required: false }], initialValue: '' }]" placeholder="请输入医嘱"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-card>
            </a-col>
          </a-row>
          <a-row v-if="!init.localed">
            <a-col :xxl="6" :xl="6" :lg="6" :md="12" :sm="12" :xs="24" class="gpws-m-b-0">
              <a-form-item :colon="false" label="取药方式" class="gpws-m-b-10" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-select v-decorator="['take', {rules: [{ required: !init.localed, message:'请选择处方流转去向.' }], initialValue: 'ABHOLUNG' }]" @change="takeDrugModelChange">
                  <a-select-option v-for="e in init.takes" :key="e.id" :value="e.id">{{ e.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xxl="4" :xl="4" :lg="4" :md="12" :sm="12" :xs="24" class="gpws-m-b-0">
              <a-form-item :colon="false" label="姓名" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-input placeholder="请输入收件人姓名" v-decorator="['consignee', {rules: [{ required: (visit.takeModel=='DELIVERY' || visit.takeModel == 'SENT_CLINIC'), message:'收件人姓名必须填写' }], initialValue: '' }]"/>
              </a-form-item>
            </a-col>
            <a-col :xxl="4" :xl="4" :lg="4" :md="12" :sm="12" :xs="24" class="gpws-m-b-0">
              <a-form-item :colon="false" label="电话" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                <a-input placeholder="请输入收件人电话" v-decorator="['consigneePhone', {rules: [{ required: (visit.takeModel=='DELIVERY' || visit.takeModel == 'SENT_CLINIC'), message:'收件人电话必须填写' }], initialValue: '' }]"/>
              </a-form-item>
            </a-col>
            <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24" class="gpws-m-b-0">
              <a-form-item :colon="false" label="详细地址" class="gpws-m-b-0" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 17, xl: 17, xxl: 17 }">
                <a-textarea placeholder="请输入收件人地址" v-decorator="['consigneeAddress', {rules: [{ required: (visit.takeModel=='DELIVERY' || visit.takeModel == 'SENT_CLINIC'), message:'收件人详细地址必须填写' }], initialValue: '' }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
        <div class="gpws-visit-btn-container" style="text-align:center;">
          <div>
            <img src="../../../assets/img/stage.png" style="cursor: pointer;user-select: none;margin-right: 20px;" @click="() => visitAction('TREATING')"/>
            <img src="../../../assets/img/visit.png" style="cursor: pointer;user-select: none;" @click="() => visitAction('RECIPED')"/>
          </div>
        </div>
      </a-form>
      <div style="position: fixed;top: 70px;right: 25px;">
        <div>
          <img src="../../../assets/img/telemed.png" style="user-select: none;cursor: pointer;" v-if="(((record.treatType||'LOCAL') === 'LOCAL') || (null == record.treatType) || ('' === record.treatType))" @click="remoteAction"/>
        </div>
        <div>
          <img src="../../../assets/img/disease.png" style="user-select: none;cursor: pointer;" @click="diseaseDrawer"/>
        </div>
        <div>
          <img src="../../../assets/img/symptom.png" style="user-select: none;cursor: pointer;" @click="symptomDrawer"/>
        </div>
        <div>
          <img src="../../../assets/img/pres.png" style="user-select: none;cursor: pointer;" @click="encyclopediaDrawer"/>
        </div>
        <div>
          <img src="../../../assets/img/favorite.png" style="user-select: none;cursor: pointer;" @click="favoriteDrawer"/>
        </div>
        <div v-if="visit.visitType == 'SUBSEQUENT_VISIT'">
          <img src="../../../assets/img/medical.png" style="user-select: none;cursor: pointer;" @click="archiveDrawer"/>
        </div>
      </div>
      <a-modal :centered="true" v-model="medical.visible" title="服药方法" @ok="medicalSelectOk" @cancel="medicalSelectCancel" :body-style="{'padding-top':'0px'}">
        <a-form>
          <a-row>
            <a-col>
              <a-form-item :colon="false" class="gpws-m-b-10" label="服用时间" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                <a-select v-model="medical.dosingTime">
                  <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'DOSING_TIME')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :colon="false" class="gpws-m-b-10" label="用法" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                <a-select v-model="medical.usage">
                  <a-select-option value="">&nbsp;</a-select-option>
                  <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'USAGE')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :colon="false" class="gpws-m-b-10" label="服用频次" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                <a-select v-model="medical.frequency">
                  <a-select-option value="">&nbsp;</a-select-option>
                  <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'FREQUENCY')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :colon="false" class="gpws-m-b-10" label="忌口" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                <a-select mode="multiple" v-model="medical.avoidFoods">
                  <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'AVOID_FOOD')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :colon="false" class="gpws-m-b-10" label="注意事项" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                <a-select mode="multiple" v-model="medical.natices">
                  <a-select-option value="">&nbsp;</a-select-option>
                  <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'DISEASE_NOTICE')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item :colon="false" class="gpws-m-b-10" label="常用医嘱" :label-col="{sm: 24, md: 12, lg: 5, xl: 5, xxl: 5 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                <a-select mode="multiple" v-model="medical.advices">
                  <a-select-option value="">&nbsp;</a-select-option>
                  <a-select-option v-for="e in (init.medicals||[]).filter(m => m.type == 'ADVICE')" :title="e.content" :value="e.content" :key="e.id">{{ e.content }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal :title="null" :centered="true" :mask-closable="false" :closable="false" :visible="supplier.visible" :footer="null" :width="600" :body-style="{'padding':'0px', 'borderRadius':'4px', 'height':'400px'}">
        <div style="width: 100%;height: 48px;text-align: center;background: rgba(99, 171, 205, 0.06);border: 1px solid #E4E7EA;border-top-right-radius: 4px; border-top-left-radius:4px;">
          <span style="font-size: 16px;line-height:48px;font-family: Alibaba PuHuiTi;font-weight: 400;color: #D02F2F;">流转处方提示</span>
          <a-button type="link" style="position: absolute; right: 24px; line-height: 48px;" @click="cancelSupplierAction">X 关闭</a-button>
        </div>
        <a-collapse v-model="supplier.current" :accordion="true">
          <a-collapse-panel v-for="(e, index) in supplier.records" :key="(index+1)" :header="e.name">
            <a-table :columns="supplier.columns" :data-source="e.drugs" size="small" :scroll="{y: 300 }" :pagination="false">
            <span slot="drugadopted" slot-scope="text, record, index">
              <a-tag color="#108ee9" v-if="record.adopted">是</a-tag>
              <a-tag color="#f50" v-else>否</a-tag>
            </span>
            </a-table>
          </a-collapse-panel>
        </a-collapse>
      </a-modal>
      <disease-drawer ref="diseaseDrawer" @clickit="loadVisitPrescription"/>
      <symptom-drawer ref="symptomDrawer" @clickit="loadVisitPrescription"/>
      <encyclopedia-drawer ref="encyclopediaDrawer" @clickit="loadVisitEncyclopedia"/>
      <favorite-drawer ref="favoriteDrawer" @clickit="loadFavoritePrescription"/>
      <telemed-drawer ref="telemedDrawer" @clickit="telemedVisitSuccess"/>
      <archive-drawer ref="archiveDrawer" v-if="visit.visitType == 'SUBSEQUENT_VISIT'" @clickit="loadVisitRecipes"/>
      <drug-modal ref="drugModal"/>
    </a-spin>
  </div>
</template>

<script>
import DiseaseDrawer from '@/components/outpatient/DiseaseDrawer.vue';
import SymptomDrawer from '@/components/outpatient/SymptomDrawer.vue';
import EncyclopediaDrawer from '@/components/outpatient/EncyclopediaDrawer.vue';
import FavoriteDrawer from '@/components/outpatient/FavoriteDrawer.vue';
import ArchiveDrawer from '@/components/outpatient/ArchiveDrawer.vue';
import TelemedDrawer from '@/components/outpatient/visit/TelemedDrawer.vue';
import DrugModal from '@/components/outpatient/DrugModal.vue';
export default {
  name: "OutpatientVisit",
  components: {
    DiseaseDrawer,
    SymptomDrawer,
    TelemedDrawer,
    EncyclopediaDrawer,
    ArchiveDrawer,
    FavoriteDrawer,
    DrugModal
  },
  data() {
    return {
      loading: false,
      loadTip: '正在提交开方信息....',
      current: {},
      drugs:[],
      complements:[],//处方补充
      converted:true,//是否可转换
      diseased:undefined,//是否为病症论治
      init:{
        localed:true,
        weighted:false,//是否录入总重量
        presaged:false,//当前处方是否来自方剂
        presopened:false,//处方说明状态
        replaceables:[],//方剂中药品可替代说明
        descType:'A',//方剂补充说明
        expands:[],//中成药（西药）扩充
        pres:{type:null, id:'', name:''},//方剂信息
        diseases:[],
        symptoms:[],
        syndromes:[],
        disposes:[],
        medicals:[],//医嘱模板
        doctors:[],//医生,
        frequencies:[],//用药频次
        handles:[{id:'SELF_FRIED',name:'自煎',type:'PIECES'}, {id:'INSTEAD_FRIED',name:'代煎',type:'PIECES'},
          {id:'POWDER',name:'打粉',type:'PIECES'}, {id:'SLICES', name:'切片',type:'PIECES'},
          {id:'WATERPILLS',name:'水丸',type:'PIECES'}, {id:'SWEETPILLS',name:'蜜丸',type:'PIECES'},
          {id:'PIECES_HERBAL_PASTE',name:'膏方',type:'PIECES'}, {id:'TEABAG',name:'袋泡茶',type:'PIECES'},
          {id:'EXTERANL',name:'外用',type:'PIECES'}, {id:'TAKE_WATER',name:'冲服',type:'GRANULE'},
          {id:'GRANULE_HERBAL_PASTE',name:'膏方',type:'GRANULE'} ],//处置
        roams:[{id:'LOCAL', name:'本机构'}, {id:'ROAM', name:'流转药房'}],
        takes:[{id:'ABHOLUNG', name:'自提'}, {id:'SENT_CLINIC', name:'送至本机构'}, {id:'DELIVERY', name:'快递'}],
        formTypes:[{id:'PIECES', name:'饮片'}, {id:'GRANULE', name:'颗粒'}]
      },
      supplier:{
        visible:false,
        current:'1',
        records:[],
        columns:[{title: '药品名', key: 'drugname', dataIndex:'drugName', width: 150},
          {title: '可流转', key: 'drugadopted', dataIndex:'adopted', align: 'center', width: 80, scopedSlots: { customRender: 'drugadopted' }},
          {title: '详细消息', key: 'drugmsg', dataIndex:'msg'}]
      },
      visit:{
        visitType:'INITIAL_VISIT',
        recipeType:'CM',
        formType:'PIECES',
        handle:'SELF_FRIED',
        takeModel:'ABHOLUNG',
        gestate:false,
        diseases:[],//选中的中医疾病
        cmdrugs:[],//当前所选择的中药
        cmrecipes:[{id:'', name:'', dosage:'', unit:'', recommend:'', units:[], usage:'', msgs:[], errored:false}],//中医处方
        disposes:[],//中医处置
        cpmrecipes:[],//中成药处方
        wmrecipes:[],//西药处方
        form: this.$form.createForm(this)
      },
      column:{
        cm:[{title: '序号', key: 'cmindex', align: 'center', width: 60, scopedSlots: { customRender: 'cmindex' }},
          {title: '药名', key: 'cmdrug', align: 'center', width: 200, scopedSlots: { customRender: 'cmdrug' }},
          {title: '剂型', key: 'cmform', align: 'center', width: 80, scopedSlots: { customRender: 'cmform' }},
          {title: '用量', key: 'cmdosage', align: 'center', width: 100, scopedSlots: { customRender: 'cmdosage' }},
          {title: '单位', key: 'cmunit', align: 'center', width: 120, scopedSlots: { customRender: 'cmunit' }},
          {title: '常用剂量', key: 'cmrecommend', align: 'center', width: 120, scopedSlots: { customRender: 'cmrecommend' }},
          {title: '备注', key: 'cmusage', scopedSlots: { customRender: 'cmusage' }},
          {title: '操作', key: 'cmoperate', align: 'center', width: 80, scopedSlots: { customRender: 'cmoperate' }}],
        dispose:[{title: '序号', key: 'dpindex', align: 'center', width: 80, scopedSlots: { customRender: 'dpindex' }},
          {title: '处置名称', key: 'dpname', align: 'center', width: 200, scopedSlots: { customRender: 'dpname' }},
          {title: '次数', key: 'dpquantity', align: 'center', width: 100, scopedSlots: { customRender: 'dpquantity' }},
          {title: '操作师', key: 'dpoperator', align: 'center', width: 170, scopedSlots: { customRender: 'dpoperator' }},
          {title: '备注', key: 'dpusage', scopedSlots: { customRender: 'dpusage' }},
          {title: '操作', key: 'dpoperate', align: 'center', width: 80, scopedSlots: { customRender: 'dpoperate' }}],
        cpm:[{title: '序号', key: 'cpmindex', align: 'center', width: 60, scopedSlots: { customRender: 'cpmindex' }},
          {title: '药名', key: 'cpmdrug', align: 'center', width: 150, scopedSlots: { customRender: 'cpmdrug' }},
          {title: '剂型规格', key: 'cpmspec', align: 'center', width: 100, scopedSlots: { customRender: 'cpmspec' }},
          {title: '单次剂量', key: 'cpmdosage', align: 'center', width: 180, scopedSlots: { customRender: 'cpmdosage' }},
          {title: '频次', key: 'cpmfrequency', align: 'center', width: 120, scopedSlots: { customRender: 'cpmfrequency' }},
          {title: '总量', key: 'cpmqty', align: 'center', width: 180, scopedSlots: { customRender: 'cpmqty' }},
          {title: '操作', key: 'cpmoperate', align: 'center', width: 80, scopedSlots: { customRender: 'cpmoperate' }}],
        wm:[{title: '序号', key: 'wmindex', align: 'center', width: 60, scopedSlots: { customRender: 'wmindex' }},
          {title: '药名', key: 'wmdrug', align: 'center', width: 150, scopedSlots: { customRender: 'wmdrug' }},
          {title: '剂型规格', key: 'wmspec', align: 'center', width: 100, scopedSlots: { customRender: 'wmspec' }},
          {title: '单次剂量', key: 'wmdosage', align: 'center', width: 180, scopedSlots: { customRender: 'wmdosage' }},
          {title: '频次', key: 'wmfrequency', align: 'center', width: 120, scopedSlots: { customRender: 'wmfrequency' }},
          {title: '总量', key: 'wmqty', align: 'center', width: 180, scopedSlots: { customRender: 'wmqty' }},
          {title: '操作', key: 'wmoperate', align: 'center', width: 80, scopedSlots: { customRender: 'wmoperate' }}]
      },
      record:{
        id:'',
        month:0,
        sbp:'',
        dbp:''
      },
      medical:{
        visible:false,
        dosingTime:'',
        usage:'',
        frequency:'',
        avoidFoods:[],
        natices:[],
        advices:[]
      }
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    }, {
      text: "门诊",
      path: ""
    }, {
      text: "开方",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    const self = this;
    this.current = JSON.parse(localStorage.getItem("curruser"));

    this.initialed();
    let id = (this.$route.query.id||'');
    let type = (this.$route.query.type||'');
    //外部选择挂号或暂存门诊进行开方
    if((id || '') != ''){
      window.setTimeout(this.loadTreatOutpatient, 1000, type, id);
    }else{
      this.backAction();
    }
  },
  methods:{
    cancelSupplierAction:function (){
      this.supplier.records=[];
      this.supplier.visible=false;
    },
    medicalSelectAction:function (){
      const self = this;
      let diseases = this.visit.form.getFieldValue('diseases');
      let symptom = this.visit.form.getFieldValue('symptom');
      this.$axios.get('/api/clinic/' + this.current.doctorId + '/medical/templates', {params:{disease:(diseases||[''])[0], symptom:symptom}}).then(function(res){
        if(res.msg.flag == 0 && null != res.biz){
          self.init.medicals =res.biz;
        }
      },function(){
      });

      this.medical.visible = true;
    },
    //服药方式选择
    medicalSelectOk:function () {
      let usages=[];
      let advices=[];
      if((this.medical.dosingTime||'') != ''){
        usages.push(this.medical.dosingTime);
      }
      if((this.medical.usage||'') != ''){
        usages.push(this.medical.usage);
      }
      if((this.medical.frequency||'') != ''){
        usages.push(this.medical.frequency);
      }
      if((this.medical.avoidFoods||[]).length > 0){
        advices.push(this.medical.avoidFoods.join('、'));
      }
      if((this.medical.natices||[]) != ''){
        advices.push(this.medical.natices.join('、'));
      }
      if((this.medical.advices||[]) != ''){
        advices.push(this.medical.advices.join('、'));
      }
      this.visit.form.setFieldsValue({'cmusage':usages.join(';')});
      this.visit.form.setFieldsValue({'cmadvice':advices.join(';')});

      this.medicalSelectCancel();
    },
    medicalSelectCancel:function (){
      Object.assign(this.medical, { visible:false, dosingTime:'', usage:'', frequency:'', avoidFoods:[], natices:[], advices:[]});
    },
    loadFavoritePrescription:function (type, id) {
      if(type === 'ENCYCLOPEDIA'){
        this.loadVisitEncyclopedia(id);
      }else if(type === 'DISEASE' || type === 'SYMPTOM'){
        this.loadVisitPrescription({id:id, symptoms:''});
      }else{
        this.loadVisitOwnPres(id);
      }
    },
    loadVisitRecipes:function (id) {
      const self = this;
      this.loading = true;
      this.loadTip='正在加载处方信息....';
      this.$axios.get('/api/clinic/local/outpatient/'+id).then(function (res) {
        self.loading=false;
        self.drugs =[];
        if (res.msg.flag == 0){
          if(undefined != res.biz && null != res.biz){
            if(undefined != res.biz.recipes && null != res.biz.recipes && res.biz.recipes.length > 0){
              res.biz.recipes.forEach(function (e) {
                if(e.type == 'CM'){
                  self.visit.formType = (e.form||'PIECES');
                  self.visit.handle=(e.model||'SELF_FRIED');
                  self.visit.cmrecipes=[];
                  self.visit.cmdrugs=[];
                  e.drugs.forEach(function (n) {
                    self.drugs.push(Object.assign(n, {msgs:[], errored:false}));
                    self.visit.cmrecipes.push(Object.assign(n, {msgs:[], errored:false}));
                    self.visit.cmdrugs.push(n);
                  });
                  self.visit.form.setFieldsValue({'doses': (e.doses||1), 'cmusage':e.usage, 'cmadvice':e.advice});
                  self.gestateChangeAction();//孕妇禁忌
                  self.conflictDrugs();//反畏效验
                  self.dosesChangeAction();//有毒
                  self.convertVerifyAction();//验证是否可剂型转换
                }
                if(e.type == 'CPM'){
                  e.drugs.forEach(function (n) {
                    self.drugs.push(Object.assign(n, {msgs:[], errored:false}));
                  });
                  self.visit.cpmrecipes=e.drugs;
                  self.visit.form.setFieldsValue({'cpmdays': (e.days||1), 'cpmusage':e.usage, 'cpmadvice':e.advice});
                }
                if(e.type == 'WM'){
                  e.drugs.forEach(function (n) {
                    self.drugs.push(Object.assign(n, {msgs:[], errored:false}));
                  });
                  self.visit.wmrecipes=e.drugs;
                  self.visit.form.setFieldsValue({'wmdays': (e.days||1), 'wmusage':e.usage, 'wmadvice':e.advice});
                }
                self.appendRecipeDrug();
              });
            }
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function (res) {
        self.loading=false;
      });
    },
    //加载方剂
    loadVisitPrescription:function(pres){
      const self = this;
      if((pres.symptoms||'') != ''){
        this.visit.form.setFieldsValue({'complaint': pres.symptoms});
      }
      this.init.presaged=false;
      this.loading = true;
      this.loadTip='正在加载方剂信息....';
      this.$axios.get('/api/clinic/' + this.current.organId + '/pres/'+pres.id).then(function (res) {
        self.loading = false;
        self.drugs=[];
        self.visit.formType = 'PIECES';
        self.visit.handle='SELF_FRIED';
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz) {
          self.init.presaged=true;
          self.visit.cmrecipes=[];
          self.visit.cmdrugs=[];
          self.init.pres ={id:res.biz.id, type:res.biz.type, name:res.biz.name, experience:res.biz.experience, appreciate:res.biz.appreciate};
          self.complements=res.biz.complements||[];
          if(undefined != res.biz.syndromes && null != res.biz.syndromes){
            let syndromes=[];
            res.biz.syndromes.forEach(function (e) {
              self.init.syndromes.push(e.name);
              syndromes.push(e.name);
            });
            self.visit.form.setFieldsValue({'syndromes': syndromes});
          }
          if(undefined != res.biz.disease && null != res.biz.disease){
            self.init.diseases = [{id:res.biz.disease.oid, name:res.biz.disease.name}];
            self.visit.form.setFieldsValue({'diseases': [res.biz.disease.oid]});
          }
          if(undefined != res.biz.symptom && null != res.biz.symptom){
            self.init.symptoms = [{id:res.biz.symptom.oid, name:res.biz.symptom.name}];
            self.visit.form.setFieldsValue({'symptom': res.biz.symptom.oid});
          }
          res.biz.drugs.forEach(function(e){
            /*(self.drugs||[]).push(e);
            if(undefined != e.interDrugs && null != e.interDrugs && e.interDrugs.length > 0){
              e.interDrugs.forEach(function(n){
                (self.drugs||[]).push(n);
              });
            }*/
            let drugs=[];
            drugs.push(Object.assign({}, e));
            if(undefined != e.interDrugs && null != e.interDrugs && e.interDrugs.length > 0){
              e.interDrugs.forEach(function(n){
                drugs.push(Object.assign({}, n));
              });
            }
            (self.visit.cmrecipes||[]).push(Object.assign(e, {drugs:drugs, msgs:[], errored:false}));
            (self.visit.cmdrugs||[]).push(e);
          });
          self.gestateChangeAction();//孕妇禁忌
          self.conflictDrugs();//反畏
          self.dosesChangeAction();//有毒
          self.convertVerifyAction();//验证是否可剂型转换
          self.replaceableDrugs();//可替换药品
          self.appendRecipeDrug();
        }
      }, function (res) {
        self.loading = false;
      });
    },
    //加载方剂大全
    loadVisitEncyclopedia:function (id) {
      const self = this;
      this.init.presaged=false;
      this.loading = true;
      this.loadTip='正在加载方剂信息....';
      this.$axios.get('/api/clinic/' + this.current.organId + '/encyc/'+id).then(function (res) {
        self.loading = false;
        self.drugs =[];
        self.visit.formType = 'PIECES';
        self.visit.handle='SELF_FRIED';
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz) {
          self.init.presaged=true;
          self.visit.cmrecipes=[];
          self.visit.cmdrugs=[];
          self.init.pres ={id:res.biz.id, type:'ENCYCLOPEDIA', name:res.biz.name, experience:res.biz.experience, appreciate:res.biz.appreciate};
          self.complements = [];
          (res.biz.expands||[]).forEach(function (e) {
            self.complements.push({desc:e});
          });
          if(undefined != res.biz.syndrome && null != res.biz.syndrome && '' != res.biz.syndrome){
            let syndromes=[res.biz.syndrome];
            self.init.syndromes = syndromes;
            self.visit.form.setFieldsValue({'syndromes': syndromes});
          }
          res.biz.drugs.forEach(function(e){
            let drugs=[];
            drugs.push(Object.assign({}, e));
            if(undefined != e.interDrugs && null != e.interDrugs && e.interDrugs.length > 0){
              e.interDrugs.forEach(function(n){
                drugs.push(Object.assign({}, n));
              });
            }
            (self.visit.cmrecipes||[]).push(Object.assign(e, {drugs:drugs, msgs:[], errored:false}));
            (self.visit.cmdrugs||[]).push(e);
          });
          self.gestateChangeAction();//孕妇禁忌
          self.conflictDrugs();//反畏
          self.dosesChangeAction();//有毒
          self.convertVerifyAction();
          self.replaceableDrugs();//可替换药品
          self.appendRecipeDrug();
        }
      }, function (res) {
        self.loading = false;
      });
    },
    appendComplement:function (index) {
      const self = this;
      this.complements[index].used = true;
      this.visit.cmrecipes.forEach(function(e, i){
        if((e.id||'') == ''){
          self.visit.cmrecipes.splice(i, 1);
        }
      });
      (this.complements[index]||{drugs:[]}).drugs.forEach(function (e) {
        if(e.plusMinus == 'PLUS'){
          if((self.visit.cmrecipes||[]).filter(m => m.id == e.id).length > 0){
            (self.visit.cmrecipes||[]).filter(m => m.id == e.id).forEach(function (n) {
              n.dosage = n.dosage + e.dosage;
            });
            (self.visit.cmdrugs||[]).filter(m => m.id == e.id).forEach(function (n) {
              n.dosage = n.dosage + e.dosage;
            });
          }else{
            (self.drugs||[]).push(e);
            (self.visit.cmrecipes||[]).push(e);
            (self.visit.cmdrugs||[]).push(e);
          }
        }else{
          if((self.visit.cmrecipes||[]).filter(m => m.id == e.id).length > 0){
            (self.visit.cmrecipes||[]).forEach(function (m, i) {
              if((m.dosage - e.dosage) > 0){
                m.dosage = m.dosage - e.dosage;
              }else{
                self.visit.cmrecipes.splice(i, 1);
              }
            });
            (self.visit.cmdrugs||[]).forEach(function (m, i) {
              if((m.dosage - e.dosage) > 0){
                m.dosage = m.dosage - e.dosage;
              }else{
                self.visit.cmdrugs.splice(i, 1);
              }
            });
          }
        }
      });

      this.gestateChangeAction();//孕妇禁忌
      this.conflictDrugs();//反畏
      this.dosesChangeAction();//有毒
      this.convertVerifyAction();//验证是否可剂型转换
      this.appendRecipeDrug();
    },
    //远程申请
    remoteAction:function (){
      this.init.localed = true;
      let params = {id: ((undefined != this.record && null != this.record && undefined != this.record.id
            && null != this.record.id && '' != this.record.id)?this.record.id:''), visitId:'',
        visitType:'INITIAL_VISIT', name:this.visit.form.getFieldValue('name'), sex:this.visit.form.getFieldValue('sex'),
        year:this.visit.form.getFieldValue('year'), month:this.record.month, idcard:this.visit.form.getFieldValue('idcard'),
        gestate:this.visit.form.getFieldValue('gestate'), phone:this.visit.form.getFieldValue('phone'), marriage: this.record.marriage,
        allergy:this.visit.form.getFieldValue('allergyHistory'), district:this.record.district, registerId: (this.record.registerId||''),
        complaint:this.visit.form.getFieldValue('complaint'), temperature:this.visit.form.getFieldValue('temperature'),
        sbp:this.record.sbp, dbp:this.record.dbp, glu:this.visit.form.getFieldValue('glu'), symptom:this.visit.form.getFieldValue('symptom'),
        diseases:this.visit.form.getFieldValue('diseases'), syndromes:this.visit.form.getFieldValue('syndromes'),
        suggest:this.visit.form.getFieldValue('suggest'), init:{diseases:this.init.diseases, symptoms:this.init.symptoms, syndromes:this.init.syndromes}};

      this.$refs.telemedDrawer.showTelemedDrawer(params);
    },
    //开方操作
    visitAction:function (status) {
      const self = this;
      this.visit.form.validateFields((err, values) => {
        if (!err) {
          if('true' == values.gestate){
            if('FEMALE' != values.sex){
              self.$message.error({content: '孕否选择有误.', duration: 1});
              return;
            }
            if(undefined == values.year || null == values.year || '' == values.year){
              self.$message.error({content: '孕否选择有误.', duration: 1});
              return;
            }
            if(parseInt(values.year)< 15 || parseInt(values.year) > 50){
              self.$message.error({content: '孕否选择有误.', duration: 1});
              return;
            }
            if(parseInt(values.year) == 50 && self.record.month > 0){
              self.$message.error({content: '孕否选择有误.', duration: 1});
              return;
            }
          }

          if((status == 'RECIPED') && (undefined == self.visit.cmrecipes || null == self.visit.cmrecipes
                  || self.visit.cmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id)).length < 1) &&
              (undefined == self.visit.disposes || null == self.visit.disposes || self.visit.disposes.length < 1) &&
              (undefined == self.visit.cpmrecipes || null == self.visit.cpmrecipes
                  || self.visit.cpmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id)).length < 1) &&
              (undefined == self.visit.wmrecipes || null == self.visit.wmrecipes
                  || self.visit.wmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id)).length < 1)){
            self.$message.error({content: '请先出具门诊处方或处置信息.', duration: 1});
            self.visit.cmrecipes = [{id:'', name:'', dosage:'', unit:'', recommend:'', units:[], usage:''}];
            return;
          }

          //中医处方验证
          let recipes=[];
          if(undefined != self.visit.cmrecipes && null != self.visit.cmrecipes
              && self.visit.cmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id)).length > 0){
            self.visit.recipeType='CM';
            let drugs =[];
            let cmrecipes= self.visit.cmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id));
            for(let i = 0; i < cmrecipes.length; i++){
              if(undefined == cmrecipes[i].id || null == cmrecipes[i].id || '' == cmrecipes[i].id){
                self.$message.error({content: '中医处方中空行请先删除.', duration: 1});
                return;
              }
              if(undefined == cmrecipes[i].dosage || null == cmrecipes[i].dosage || '' == cmrecipes[i].dosage){
                self.$message.error({content: '中医处方中药品[' + cmrecipes[i].name + ']用量未设置.', duration: 1});
                return;
              }
              if(undefined == cmrecipes[i].unit || null == cmrecipes[i].unit || '' == cmrecipes[i].unit){
                self.$message.error({content: '中医处方中药品[' + cmrecipes[i].name + ']用量单位未设置.', duration: 1});
                return;
              }

              drugs.push({id:cmrecipes[i].id, dosage:cmrecipes[i].dosage, salePrice:cmrecipes[i].salePrice,
                saleQty:cmrecipes[i].saleQty, saleUnit:cmrecipes[i].saleUnit, unit:cmrecipes[i].unit,
                frequency:cmrecipes[i].frequency, usage:cmrecipes[i].usage});
            }
            if((this.visit.handle||'') == ''){
              self.$message.error({content: '请选择中医处方加工方式.', duration: 1});
              return;
            }
            recipes.push({type:'CM', usageModel:this.visit.handle, doses:values.doses, dispose:values.cmroam,
              usage:values.cmusage, advice:values.cmadvice, drugs:drugs});
          }
          //中医处置验证
          if(undefined != self.visit.disposes && null != self.visit.disposes && self.visit.disposes.length > 0){
            self.visit.recipeType='DISPOSE';
            for(let i =0; i< self.visit.disposes.length; i++){
              if(undefined == self.visit.disposes[i].id || null == self.visit.disposes[i].id || '' == self.visit.disposes[i].id){
                self.$message.error({content: '中医处置中空行请先删除.', duration: 1});
                return;
              }
              if(undefined == self.visit.disposes[i].quantity || null == self.visit.disposes[i].quantity || '' == self.visit.disposes[i].quantity){
                self.$message.error({content: '中医处置[' + self.visit.disposes[i].name + ']次数未设置.', duration: 1});
                return;
              }
              if(undefined == self.visit.disposes[i].operator || null == self.visit.disposes[i].operator || '' == self.visit.disposes[i].operator){
                self.$message.error({content: '中医处置[' + self.visit.disposes[i].name + ']操作师未设置.', duration: 1});
                return;
              }
            }
          }

          //中成药验证
          if(undefined != self.visit.cpmrecipes && null != self.visit.cpmrecipes
              && self.visit.cpmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id)).length > 0){
            self.visit.recipeType='CPM';
            let drugs=[];
            let cpmrecipes = self.visit.cpmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id));
            for(let i =0; i< cpmrecipes.length; i++){
              if(undefined == cpmrecipes[i].id || null == cpmrecipes[i].id || '' == cpmrecipes[i].id){
                self.$message.error({content: '中成药处方中空行请先删除.', duration: 1});
                return;
              }
              if(undefined == cpmrecipes[i].dosage || null == cpmrecipes[i].dosage || '' == cpmrecipes[i].dosage){
                self.$message.error({content: '中成药处方中药品[' + cpmrecipes[i].name + ']单次剂量未设置.', duration: 1});
                return;
              }
              if(undefined == cpmrecipes[i].unit || null == cpmrecipes[i].unit || '' == cpmrecipes[i].unit){
                self.$message.error({content: '中成药处方中药品[' + cpmrecipes[i].name + ']单次剂量单位未设置.', duration: 1});
                return;
              }
              if(undefined == cpmrecipes[i].frequency || null == cpmrecipes[i].frequency || '' == cpmrecipes[i].frequency){
                self.$message.error({content: '中成药处方中药品[' + cpmrecipes[i].name + ']频次未设置.', duration: 1});
                return;
              }
              if(undefined == cpmrecipes[i].saleQty || null == cpmrecipes[i].saleQty || '' == cpmrecipes[i].saleQty){
                self.$message.error({content: '中成药处方中药品[' + cpmrecipes[i].name + ']总量未设置.', duration: 1});
                return;
              }
              if(undefined == cpmrecipes[i].saleUnit || null == cpmrecipes[i].saleUnit || '' == cpmrecipes[i].saleUnit){
                self.$message.error({content: '中成药处方中药品[' + cpmrecipes[i].name + ']总量单位未设置.', duration: 1});
                return;
              }

              drugs.push({id:cpmrecipes[i].id, dosage:cpmrecipes[i].dosage, salePrice:cpmrecipes[i].salePrice,
                saleQty:cpmrecipes[i].saleQty, saleUnit:cpmrecipes[i].saleUnit, unit:cpmrecipes[i].unit,
                frequency:cpmrecipes[i].frequency, usage:cpmrecipes[i].usage});
            }
            recipes.push({type:'CPM', dispose:values.cpmroam, usage:values.cpmusage, advice:values.cpmadvice, drugs:drugs});
          }

          //西药验证
          if(undefined != self.visit.wmrecipes && null != self.visit.wmrecipes
              && self.visit.wmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id)).length > 0){
            self.visit.recipeType='WM';
            let drugs=[];
            let wmrecipes = self.visit.wmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id));
            for(let i = 0; i< wmrecipes.length; i++){
              if(undefined == wmrecipes[i].id || null == wmrecipes[i].id || '' == wmrecipes[i].id){
                self.$message.error({content: '西药处方中空行请先删除.', duration: 1});
                return;
              }
              if(undefined == wmrecipes[i].dosage || null == wmrecipes[i].dosage || '' == wmrecipes[i].dosage){
                self.$message.error({content: '西药处方中药品[' + wmrecipes[i].name + ']单次剂量未设置.', duration: 1});
                return;
              }
              if(undefined == wmrecipes[i].unit || null == wmrecipes[i].unit || '' == wmrecipes[i].unit){
                self.$message.error({content: '西药处方中药品[' + wmrecipes[i].name + ']单次剂量单位未设置.', duration: 1});
                return;
              }
              if(undefined == wmrecipes[i].frequency || null == wmrecipes[i].frequency || '' == wmrecipes[i].frequency){
                self.$message.error({content: '西药处方中药品[' + wmrecipes[i].name + ']频次未设置.', duration: 1});
                return;
              }
              if(undefined == wmrecipes[i].saleQty || null == wmrecipes[i].saleQty || '' == wmrecipes[i].saleQty){
                self.$message.error({content: '西药处方中药品[' + wmrecipes[i].name + ']总量未设置.', duration: 1});
                return;
              }
              if(undefined == wmrecipes[i].saleUnit || null == wmrecipes[i].saleUnit || '' == wmrecipes[i].saleUnit){
                self.$message.error({content: '西药处方中药品[' + wmrecipes[i].name + ']总量单位未设置.', duration: 1});
                return;
              }

              drugs.push({id:wmrecipes[i].id, dosage:wmrecipes[i].dosage, salePrice:wmrecipes[i].salePrice,
                saleQty:wmrecipes[i].saleQty, saleUnit:wmrecipes[i].saleUnit, unit:wmrecipes[i].unit,
                frequency:wmrecipes[i].frequency, usage:wmrecipes[i].usage});
            }
            recipes.push({type:'WM', dispose:values.wmroam, usage:values.wmusage, advice:values.wmadvice, drugs:drugs});
          }

          let params = {id: ((undefined != self.record && null != self.record && undefined != self.record.id
                && null != self.record.id && '' != self.record.id)?self.record.id:''), registerId: (self.record.registerId||''),
            patientId: self.record.memberId, allergyHistory:values.allergyHistory, visitType:self.visit.visitType,
            visitId:self.record.visitId, name:values.name, sex:values.sex, year:values.year, month:self.record.month,
            idcard:values.idcard, marriage:(self.record.marriage||null), gestate:values.gestate, phone:values.phone,
            recipes:recipes, complaint:values.complaint, physical:{temperature:values.temperature, sbp:self.record.sbp,
              dbp:self.record.dbp, glu:values.glu}, status:status, diseases:values.diseases, symptom:values.symptom,
            syndromes:values.syndromes, suggest:values.suggest, disposals: self.visit.disposes, presType:self.init.pres.type,
            presId:self.init.pres.id, presName:self.init.pres.name, take:values.take, consignee:values.consignee,
            consigneePhone:values.consigneePhone, consigneeAddress:values.consigneeAddress,
            treatType:((undefined != self.record && null != self.record && undefined != self.record.treatType
                && null != self.record.treatType && '' != self.record.treatType)?self.record.treatType:'LOCAL')};

          self.loading = true;
          self.loadTip='正在'+(status=='TREATING'?'暂存':'提交')+'开方信息,请稍候...';
          self.$axios.post('/api/clinic/' + self.current.organId + '/outpatient/visit', params).then(function(res){
            if(res.msg.flag == 0){
              if(undefined != res.biz && null != res.biz){
                self.record.id = res.biz.id;
                if(res.biz.adopted){
                  if(status == 'TREATING'){
                    self.loading=false;
                    self.$message.success({content: '门诊开方暂存成功.', duration: 2});
                  }else{
                    self.$axios.post('/api/clinic/outpatient/'+self.record.id+'/reciped').then(function(rs){
                      self.loading = false;
                      if(rs.msg.flag == 0){
                        self.$message.success({content: '门诊开方保存成功.', duration: 2});
                        self.backAction();
                      }else{
                        self.$message.error({content: rs.msg.message, duration: 2});
                      }
                    },function(res){
                      self.loading = false;
                    });
                  }
                }else{
                  self.loading = false;
                  self.supplier.records = res.biz.suppliers;
                  self.supplier.visible = true;
                }
              }else{
                self.$message.error({content: '门诊开方返回为空.', duration: 2});
              }
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(res){
            self.loading=false;
          });
        }
      });
    },
    telemedVisitSuccess:function (){
      this.backAction();
    },
    //添加中医处置
    appendDispose:function (){
      this.visit.disposes.push({id:'', name:'', quantity:1, price:'', unit:'', operator:'', amount:0, describe:''});
    },
    autoCompleteDisposeSelect:function (value, index) {
      const self = this;
      this.init.disposes.forEach(function (e, i) {
        if(e.id == value){
          let amount = 0;
          if(undefined != e.price && null != e.price){
            amount = e.price;
          }

          self.visit.disposes.splice(index, 1, {id:e.id, name:e.name, quantity:1,
            price:e.price, unit:e.unit, operator:self.current.doctorId, amount:amount, describe:''});
        }
      });
    },
    deleteDispose:function(index){
      this.visit.disposes.splice(index, 1);
    },
    //添加药品
    appendRecipeDrug:function(){
      if(this.visit.recipeType == 'CM'){
        if((this.visit.cmrecipes||[]).filter(e => (undefined == e.id || null == e.id || '' == e.id)).length <=0){
          this.visit.cmrecipes.push({id:'', name:'', dosage:'', unit:'', recommend:'', units:[], usage:'', msgs:[], errored:false});
        }
      }
      if(this.visit.recipeType == 'CPM'){
        if((this.visit.cpmrecipes||[]).filter(e => (undefined == e.id || null == e.id || '' == e.id)).length <=0){
          this.visit.cpmrecipes.push({id:'', name:'', dosage:'', form:'', spec:'', salePrice:'', unit:'',
            frequency:'', units:[], saleQty:1, saleUnit:'', saleUnits:[]});
        }
      }
      if(this.visit.recipeType == 'WM'){
        if((this.visit.wmrecipes||[]).filter(e => (undefined == e.id || null == e.id || '' == e.id)).length <=0){
          this.visit.wmrecipes.push({id:'', name:'', dosage:'', form:'', spec:'', salePrice:'', unit:'',
            frequency:'', units:[], saleQty:1, saleUnit:'', saleUnits:[]});
        }
      }
    },
    deleteDrugs:function (id, index, type) {
      const self = this;
      if(this.visit.recipeType == 'CM'){
        this.visit.cmrecipes.splice(index, 1);
        this.visit.cmdrugs.forEach(function (e, n) {
          if(e.id == id || e.insteadId == id){
            self.visit.cmdrugs.splice(n, 1);
          }
        });
        if(index == 0){
          this.appendRecipeDrug();
        }
        this.gestateChangeAction();
        this.conflictDrugs();
        this.dosesChangeAction();//有毒
        this.convertVerifyAction();//验证是否可剂型转换
      }
      if(this.visit.recipeType == 'CPM'){
        this.visit.cpmrecipes.splice(index, 1);
      }
      if(this.visit.recipeType == 'WM'){
        this.visit.wmrecipes.splice(index, 1);
      }
    },
    cleanDrugRecipe:function(id, index, type){
      const self= this;
      if(type == 'CM'){
        this.visit.cmrecipes.splice(index, 1, {id:'', name:'', dosage:'', unit:'', recommend:'', units:[], usage:'', msgs:[], errored:false});
        if((id||'') != ''){
          this.visit.cmdrugs.forEach(function (e, n) {
            if(e.id == id || e.insteadId == id){
              self.visit.cmdrugs.splice(n, 1);
            }
          });
        }
      }
      if(type == 'CPM'){
        this.visit.cpmrecipes.splice(index, 1, {id:'', name:'', dosage:'', form:'', spec:'', salePrice:'', unit:'',
          frequency:'', units:[], saleQty:1, saleUnit:'', saleUnits:[]});
      }
      if(type == 'WM'){
        this.visit.wmrecipes.splice(index, 1, {id:'', name:'', dosage:'', form:'', spec:'', salePrice:'', unit:'',
          frequency:'', units:[], saleQty:1, saleUnit:'', saleUnits:[]});
      }
    },
    autoCompleteDrugFocus:function (id, index, type) {
      if(undefined != this.timeHandler || null != this.timeHandler){
        window.clearTimeout(this.timeHandler);
      }

      if(undefined != id && null != id && '' != id){
        let value ='';
        if(this.visit.cmdrugs.filter(e => (e.id === id)).length > 0){
          value = (this.visit.cmdrugs.filter(e => (e.id === id))[0]).name;
        }
        if(undefined != value && null != value && '' != value){
          this.timeHandler = window.setTimeout(this.drugSearch, 1000, value, id, index, type);
        }
      }
    },
    autoCompleteDrugSearch:function(value, id, index, type){
      const self = this;
      this.drugs = [];
      this.cleanDrugRecipe(id, index, type);
      let formType = '';
      if(this.visit.recipeType == 'CM'){
        formType = this.visit.formType;
      }
      if(undefined != value && null != value && '' != value && value.trim().length > 0){
        this.$axios.get('/api/clinic/drug/query', {params:{keyword:value, type:type, form:formType, length:20}}).then(function (res) {
          if (res.msg.flag == 0) {
            self.drugs = [];
            if(null != res.biz && !res.biz.empty){
              res.biz.forEach(function(e){
                self.drugs.push(Object.assign(e, {saleQty:1}));
              });
            }
          }
        }, function (res) {
        });
      }
    },
    autoCompleteDrugSelect:function(value, index, type){
      const self = this;
      if(type == 'CM'){
        if((this.visit.cmrecipes[index].drugs||[]).length > 1){
          (this.visit.cmrecipes[index].drugs||[]).forEach(function (e, i) {
            if(e.id == value){
              self.visit.cmrecipes.splice(index, 1, Object.assign(Object.assign({}, e), {drugs: (self.visit.cmrecipes[index].drugs||[]), msgs:[], errored:false}));
              self.visit.cmdrugs.splice(index, 1, Object.assign({}, e));
            }
          });
        }else{
          this.drugs.forEach(function (e, i) {
            if(e.id == value){
              self.visit.cmrecipes.splice(index, 1, Object.assign(Object.assign({}, e), { msgs:[], errored:false}));
              self.visit.cmdrugs.splice(index, 1, Object.assign({}, e));
              self.appendRecipeDrug();
            }
          });
        }
        self.gestateChangeAction();//孕妇禁忌
        self.conflictDrugs();//反畏效验
        self.dosesChangeAction();//有毒
        self.convertVerifyAction();//验证是否可转换剂型
        self.drugChangeWeightAction();//总重计算
        self.replaceableDrugs();
      }else{
        this.drugs.forEach(function (e, i) {
          if(e.id == value){
            if(type == 'CPM'){
              self.visit.cpmrecipes.splice(index, 1, Object.assign({}, e));
            }
            if(type == 'WM'){
              self.visit.wmrecipes.splice(index, 1, Object.assign({}, e));
            }
            self.appendRecipeDrug();
          }
        });
      }
      window.setTimeout(this.drugClear, 1000);
    },
    drugClear:function () {
      this.drugs=[];
    },
    drugChangeWeightAction:function (){
      if(this.init.weighted){
        let weight=0.0;
        this.visit.cmrecipes.forEach(function (e) {
          weight = weight + (e.dosage||0);
        });

        window.setTimeout(this.setWeight,100, weight);
      }
    },
    weightChangeAction:function (){
      let weight=0.0;
      this.visit.cmrecipes.forEach(function (e) {
        weight = weight + (e.dosage||0);
      });
      if(weight > 0){
        let total = this.visit.form.getFieldValue('weight');
        this.visit.cmrecipes.forEach(function (e) {
          e.dosage = parseFloat(((e.dosage||0) * parseFloat(total) / weight).toFixed(1));
        });
      }
    },
    setWeight: function(weight){
      this.visit.form.setFieldsValue({'weight':weight});
    },
    //中药用量改变
    cmDrugDosesChange:function (value, id, index) {
      let items = this.visit.cmrecipes.filter(m => m.id == id);
      if((items||[]).length > 0){
        items.forEach(function (e) {
          if(e.toxic && parseFloat(value) > (e.maxDosage||0)){//有毒药品使用量超过推荐最高用量
            if((e.msgs||[]).filter(m => m.type === 'toxic').length <= 0){
              e.msgs.push({type:'toxic', msg:'具有毒性,请勿超过推荐用量'});
              e.errored = true;
            }
          }else{
            if((e.msgs||[]).filter(m => m.type === 'toxic').length > 0){
              let msgs = e.msgs.filter(m => m.type != 'toxic');
              e.msgs = msgs;
            }
            e.errored = (e.msgs||[]).length > 0;
          }
        });
        this.equitableDrugs();
      }
    },
    dosesChangeAction:function (){
      let items = this.visit.cmrecipes.filter(m => m.toxic);
      if((items||[]).length > 0){
        items.forEach(function (e) {
          if(parseFloat(e.dosage) > e.maxDosage){//有毒药品使用量超过推荐最高用量
            if((e.msgs||[]).filter(m => m.type === 'toxic').length <= 0){
              e.msgs.push({type:'toxic', msg:'具有毒性,请勿超过推荐用量'});
              e.errored = true;
            }
          }else{
            if((e.msgs||[]).filter(m => m.type === 'toxic').length > 0){
              let msgs = e.msgs.filter(m => m.type != 'toxic');
              e.msgs = msgs;
            }
            e.errored = (e.msgs||[]).length > 0;
          }
        });
        this.equitableDrugs();
      }
    },
    initialed:function () {
      const self = this;
      if(localStorage.getItem('frequencies')){
        this.init.frequencies = JSON.parse(localStorage.getItem("frequencies"));
      }else{
        this.getFrequencies(function (res){
          self.init.frequencies = res;
          localStorage.setItem("frequencies", JSON.stringify(res));
        });
      }

      this.getDoctors({params:{organId:this.current.organId}}, function (res) {
        self.init.doctors =res;
      });

      this.$axios.get('/api/clinic/dispose/keyword').then(function (res) {
        if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
          self.init.disposes =res.biz;
        }
      }, function (res) {
      });
    },
    backAction:function (){
      this.$router.push({ path : '/layout/outpatient' });
    },
    onRoamChange:function (value, type) {
      let roamOne='LOCAL', roamTwo='LOCAL';
      if(type == 'CM'){
        roamOne = this.visit.form.getFieldValue('cpmroam');
        roamTwo = this.visit.form.getFieldValue('wmroam');
      }
      if(type == 'CPM'){
        roamOne = this.visit.form.getFieldValue('cmroam');
        roamTwo = this.visit.form.getFieldValue('wmroam');
      }
      if(type == 'WM'){
        roamOne = this.visit.form.getFieldValue('cmroam');
        roamTwo = this.visit.form.getFieldValue('cpmroam');
      }
      if('LOCAL' == value && 'LOCAL' == roamOne && 'LOCAL' == roamTwo){
        this.init.localed = true;
      }else{
        this.init.localed = false;
        window.setTimeout(this.setConsignee,500);
      }
    },
    setConsignee:function (){
      let name= this.visit.form.getFieldValue('name');
      let phone = this.visit.form.getFieldValue('phone');
      this.visit.form.setFieldsValue({'consignee':name, 'consigneePhone':phone});
    },
    //病症论证
    diseaseDrawer:function (){
      let year = this.visit.form.getFieldValue('year');
      let sex = this.visit.form.getFieldValue('sex');

      this.$refs.diseaseDrawer.showDiseaseDrawer(sex, year, this.record.month);
    },
    //症症论证
    symptomDrawer:function (){
      let year = this.visit.form.getFieldValue('year');
      let sex = this.visit.form.getFieldValue('sex');
      this.$refs.symptomDrawer.showSymptomDrawer(sex, year, this.record.month);
    },
    encyclopediaDrawer:function (){
      this.$refs.encyclopediaDrawer.showEncyclopediaDrawer();
    },
    favoriteDrawer:function (){
      this.$refs.favoriteDrawer.showFavoriteDrawer();
    },
    archiveDrawer:function (){
      if(undefined == this.record.memberId || null == this.record.memberId || '' == this.record.memberId){
        this.$message.info({content:'本次门诊不为复诊.', duration:2 });
        return;
      }
      this.$refs.archiveDrawer.showArchiveDrawer(this.record.memberId, 'LOCAL');
    },
    //剂型切换
    formTypeChange:function (value){
      this.drugs=[];
      this.visit.formType = value;
      if('PIECES' == this.visit.formType){
        this.visit.handle='SELF_FRIED';
      }else{
        this.visit.handle='TAKE_WATER';
      }
      this.convertAction(value);
    },
    handleChangeAction:function (value){
      if(value ==='SELF_FRIED' || value ==='INSTEAD_FRIED' || value ==='TAKE_WATER'){
        this.weighted=false;
      }else{
        this.weighted=true;
      }
    },
    //处方类型切换
    recipeChange:function (key) {
      this.visit.recipeType = key;
      this.drugs=[];
    },
    takeDrugModelChange:function (value) {
      this.visit.takeModel = value;
      if(value == 'SENT_CLINIC'){
        this.visit.form.setFieldsValue({'consignee':this.current.name, 'consigneePhone':this.current.mobile, 'consigneeAddress':this.current.address});
      }else if(value == 'DELIVERY'){
        let name= this.visit.form.getFieldValue('name');
        let phone = this.visit.form.getFieldValue('phone');
        this.visit.form.setFieldsValue({'consignee':name, 'consigneePhone':phone, 'consigneeAddress':this.record.address});
      }else{
        this.visit.form.setFieldsValue({'consignee':'', 'consigneePhone':'', 'consigneeAddress':''});
      }
    },
    handleDiseaseFocus:function(){
      this.init.diseases=[];
    },
    handleDiseaseSelect:function(value){
      const self = this;
      this.init.diseases.forEach(function(e, m){
        if(e.id == value && self.visit.diseases.filter(n => n.id == e.id).length <= 0){
          self.visit.diseases.push(e);
        }
      });
      this.diseased = true;
      this.loadSyndromes();
    },
    handleDiseaseCancel:function(value){
      const self = this;
      let data = new Array();
      let deleteIndex=-1;
      Object.assign(data, this.visit.diseases);
      this.visit.diseases.forEach(function(e, m){
        if(e.id == value){
          deleteIndex = m;
        }
      });
      if(deleteIndex>=0){
        data.splice(deleteIndex, 1);
      }
      this.visit.diseases = data;
      if((this.visit.diseases||[]).length <= 0){
        this.diseased = undefined;
      }else{
        this.diseased = true;
      }
      this.loadSyndromes();
    },
    loadSyndromes:function(){
      const self = this;
      this.init.syndromes = [];

      this.visit.diseases.forEach(function (e, i) {
        if(undefined != e.syndromes && null != e.syndromes && e.syndromes.length > 0){
          (e.syndromes||[]).forEach(function (m, n) {
            if(self.init.syndromes.filter(a => a == m.name).length <= 0){
              self.init.syndromes.push(m.name);
            }
          });
        }
      });
    },
    //疾病查询
    //疾病查询
    handleDiseaseSearch:function (value) {
      if(undefined != this.timeHandler || null != this.timeHandler){
        window.clearTimeout(this.timeHandler);
      }
      this.timeHandler = window.setTimeout(this.diseaseSearch, 1000, value);
    },
    diseaseSearch:function (value) {
      const self = this;
      this.init.diseases=[];

      let sex = this.visit.form.getFieldValue('sex');
      let year = this.visit.form.getFieldValue('year');

      if(undefined != value && null != value && '' != value && value.length > 1){
        this.$axios.get('/api/clinic/diseases', {params:{keyword:value, sex:sex,
            year:year, month:self.record.month}}).then(function (res) {
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            self.init.diseases=res.biz;
          }
        }, function (res) {
        });
      }
    },
    mainSymptomSearch:function(value){
      if(undefined != this.timeHandler || null != this.timeHandler){
        window.clearTimeout(this.timeHandler);
      }
      this.timeHandler = window.setTimeout(this.symptomSearch, 1000, value);
    },
    symptomSearch:function (value) {
      const self = this;
      let sex = this.visit.form.getFieldValue('sex');
      let year = this.visit.form.getFieldValue('year');

      let months = ((year||0) * 12) + this.record.month;

      this.init.symptoms=[];
      if(undefined != value && null != value && '' != value && value.trim().length > 0){
        this.$axios.get('/api/clinic/position/symptoms', {params:{keyword:value, sex:sex, months:months, common:true}}).then(function (res) {
          self.init.symptoms =[];
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            res.biz.forEach(function(e){
              if(undefined != e.children && null != e.children && e.children.length > 0){
                e.children.forEach(function (m) {
                  self.init.symptoms.push(m);
                });
              }
            });
          }
        }, function (res) {
        });
      }
    },
    mainSymptomSelect:function (value) {
      const self = this;
      this.init.syndromes=[];
      if(undefined != value && null != value && '' != value){
        this.$axios.get('/api/clinic/symptom/' + value + '/syndromes').then(function (res) {
          res.biz.forEach(function(e){
            self.init.syndromes.push(e.value);
          });
        }, function (res) {
        });
        this.diseased = false;
      }else{
        this.diseased = undefined;
      }
    },
    gestateChangeAction:function (value){
      //孕妇禁忌
      let gestate = value||this.visit.form.getFieldValue('gestate');
      (this.visit.cmrecipes||[]).forEach(function(e){
        if(gestate === 'true'){
          if((e.caution||'') === 'PREGNANCY_CAUTION'){
            let items = (e.msgs||[]).filter(m => m.type === 'caution');
            if((items||[]).length <= 0){
              e.msgs = (e.msgs||[]);
              e.msgs.push({type:'caution', msg:'为妊娠慎用药品'});
            }
          }
          if((e.caution||'') === 'PREGNANCY_FORBIDDEN'){
            let items = (e.msgs||[]).filter(m => m.type === 'forbidden');
            if((items||[]).length <= 0){
              e.msgs = (e.msgs||[]);
              e.msgs.push({type:'forbidden', msg:'为妊娠禁用药品'});
            }
          }
        }else{
          if((e.msgs||[]).length > 0){
            let msgs = e.msgs.filter(m => (m.type != 'caution' && m.type != 'forbidden'));
            e.msgs = msgs;
          }
        }
        e.errored =(e.msgs||[]).length > 0;
      });

      this.equitableDrugs();
    },
    //合理用药
    equitableDrugs:function () {
      if(!this.init.presaged){
        this.init.presaged = (this.visit.cmrecipes||[]).filter(m => m.errored).length > 0;
      }
      if(!this.init.presopened){
        this.init.presopened = (this.visit.cmrecipes||[]).filter(m => m.errored).length > 0;
      }
      if((this.visit.cmrecipes||[]).filter(m => m.errored).length > 0){
        this.init.descType='B';
      }
      this.$forceUpdate();
    },
    //药品可替换提醒
    replaceableDrugs:function (){
      const self = this;
      this.init.replaceables=[];
      (this.visit.cmrecipes||[]).forEach(function(e){
        if(undefined != e.interDrugs && null != e.interDrugs && e.interDrugs.length > 0){
          self.init.replaceables.push({name:e.name, replaceable:e.interDrugs.map(n => n.name).join(',')});
        }
      });

      if((this.init.replaceables||[]).length > 0){
        this.init.presopened = true;
        this.init.descType='B';
      }
    },
    //反畏药品
    conflictDrugs:function (){
      const self = this;
      (this.visit.cmrecipes||[]).forEach(function(e, index){
        let msgs = (e.msgs||[]).filter(m => m.type === 'conflict');
        if((msgs||[]).length > 0){
          let msgs = e.msgs.filter(m => m.type != 'conflict');
          e.msgs = msgs;
          e.errored = (e.msgs||[]).length > 0;
        }
        if((e.conflicts||[]).length > 0){
          let conflicts =[];
          for(let i=0; i< (e.conflicts||[]).length; i++){
            for(let n = (index+1); n < (self.visit.cmrecipes||[]).length; n++){
              if(self.visit.cmrecipes[n].id != e.id && (self.visit.cmrecipes[n].name == e.conflicts[i] || (self.visit.cmrecipes[n].alias||[]).includes(e.conflicts[i]))){
                conflicts.push(self.visit.cmrecipes[n].name);
                self.visit.cmrecipes[n].errored = true;
              }
            }
          }
          if(conflicts.length > 0){
            let items = (e.msgs||[]).filter(m => m.type === 'conflict');
            if((items||[]).length <= 0){
              e.msgs = (e.msgs||[]);
              e.msgs.push({type:'conflict', msg:'与药品['+conflicts.join(',')+']违反了十八反十九畏'});
              e.errored = true;
            }
          }
        }
      });
      this.equitableDrugs();
    },
    gestateSexChange: function (value) {
      let age = this.visit.form.getFieldValue('year');

      if (undefined != value && null != value && '' != value && undefined != age && null != age) {
        if (parseInt(age) >= 15 && parseInt(age) < 50 && value == 'FEMALE') {
          this.visit.gestate = true;
        } else if(parseInt(age) == 50 && this.record.month <=0 && value == 'FEMALE'){
          this.visit.gestate = true;
        } else {
          this.visit.gestate = false;
          this.visit.form.setFieldsValue({'gestate': 'false'});
        }
      } else {
        this.visit.gestate = false;
        this.visit.form.setFieldsValue({'gestate': 'false'});
      }
    },
    gestateAgeMonthChange:function (){
      let sex = this.visit.form.getFieldValue('sex');
      let age = this.visit.form.getFieldValue('year');

      if (undefined != sex && null != sex && '' != sex && undefined != age && null != age) {
        if (parseInt(age) >= 15 && parseInt(age) < 50 && sex == 'FEMALE') {
          this.visit.gestate = true;
        } else if(parseInt(age) == 50 && this.record.month <= 0 && sex == 'FEMALE'){
          this.visit.gestate = true;
        } else {
          this.visit.gestate = false;
          this.visit.form.setFieldsValue({'gestate': 'false'});
        }
      } else {
        this.visit.gestate = false;
        this.visit.form.setFieldsValue({'gestate': 'false'});
      }
    },
    gestateAgeChange: function (value) {
      let sex = this.visit.form.getFieldValue('sex');

      if (undefined != sex && null != sex && '' != sex && undefined != value && null != value) {
        if (parseInt(value) >= 15 && parseInt(value) < 50 && sex == 'FEMALE') {
          this.visit.gestate = true;
        } else if(parseInt(value) == 50 && this.record.month <=0 && sex == 'FEMALE'){
          this.visit.gestate = true;
        } else {
          this.visit.gestate = false;
          this.visit.form.setFieldsValue({'gestate': 'false'});
        }
      } else {
        this.visit.gestate = false;
        this.visit.form.setFieldsValue({'gestate': 'false'});
      }
    },
    //加载挂号或辅诊中门诊信息
    loadTreatOutpatient:function (type, id){
      const self = this;
      this.loadTip='正在加载'+(type =='OUTPATIENT'?'暂存门诊':'挂号')+'信息,请稍候....';
      this.loading=true;
      if(type =='REGISTER'){
        this.$axios.get('/api/clinic/register/'+id).then(function (res) {
          self.loading=false;
          if (res.msg.flag == 0){
            if(undefined != res.biz && null != res.biz){
              self.record = res.biz;
              self.record.registerId = res.biz.id;
              self.record.id = '';
              self.visit.visitType = res.biz.visitType||'INITIAL_VISIT';

              if (undefined != res.biz.sex && null != res.biz.sex && undefined != res.biz.year && null != res.biz.year) {
                if (parseInt(res.biz.year) >= 15 && parseInt(res.biz.year) < 50 && res.biz.sex == 'FEMALE') {
                  self.visit.gestate = true;
                } else if(parseInt(res.biz.year) == 50 && (res.biz.month||0) <= 0 && res.biz.sex == 'FEMALE'){
                  self.visit.gestate = true;
                } else {
                  self.visit.gestate = false;
                }
              } else {
                self.visit.gestate = false;
              }

              self.onBlurIdcard();
            }
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function (res) {
          self.loading=false;
        });
      }else{
        this.$axios.get('/api/clinic/local/outpatient/'+id).then(function (res) {
          self.loading=false;
          if (res.msg.flag == 0){
            if(undefined != res.biz && null != res.biz){
              self.record = {id:res.biz.id, treatType:res.biz.treatType, visitType:res.biz.visitType,
                registerId:res.biz.registerId, name: res.biz.patient.name, sex: res.biz.patient.sex,
                year: (res.biz.patient.year||{age:''}).age, month: (res.biz.patient.month||{age:''}).age, idcard: res.biz.patient.idcard,
                phone: res.biz.patient.phone, gestate:res.biz.gestate, complaint:res.biz.complaint, district:res.biz.patient.address,
                temperature:res.biz.temperature, sbp:res.biz.sbp, dbp:res.biz.dbp, glu:res.biz.glu, visitId:res.biz.visitId,
                allergy:res.biz.allergy, marriage: res.biz.patient.marriage, memberId: res.biz.patient.oid};
              self.visit.visitType = res.biz.visitType||'INITIAL_VISIT';

              if (undefined != res.biz.sex && null != res.biz.sex && undefined != res.biz.year && null != res.biz.year) {
                if (parseInt(res.biz.year) >= 15 && parseInt(res.biz.year) < 50 && res.biz.sex == 'FEMALE') {
                  self.visit.gestate = true;
                } else if(parseInt(res.biz.year) == 50 && (res.biz.month||0) <= 0 && res.biz.sex == 'FEMALE'){
                  self.visit.gestate = true;
                } else {
                  self.visit.gestate = false;
                }
              } else {
                self.visit.gestate = false;
              }

              if(undefined != res.biz.diagnostic && null != res.biz.diagnostic){
                if(undefined != res.biz.diagnostic.diseases && null != res.biz.diagnostic.diseases && res.biz.diagnostic.diseases.length > 0){
                  res.biz.diagnostic.diseases.forEach(function (e) {
                    self.init.diseases.push({id:e.oid, name:e.name});
                  });
                  self.diseased = true;
                  self.record.diseases = res.biz.diagnostic.diseases.map(m => m.oid);
                }
                if(undefined != res.biz.diagnostic.symptom && null != res.biz.diagnostic.symptom){
                  self.init.symptoms.push({id:res.biz.diagnostic.symptom.oid, name:res.biz.diagnostic.symptom.name});
                  self.diseased = false;
                  self.record.symptom = res.biz.diagnostic.symptom.oid;
                }
                self.record.syndromes = res.biz.diagnostic.syndromes||[];
                self.init.syndromes = res.biz.diagnostic.syndromes||[];
                self.record.suggest = res.biz.diagnostic.suggest;
              }
              if(undefined != res.biz.recipes && null != res.biz.recipes && res.biz.recipes.length > 0){
                res.biz.recipes.forEach(function (e) {
                  if(e.type == 'CM'){
                    self.visit.formType = (e.form||'PIECES');
                    self.visit.handle=(e.model||'SELF_FRIED');
                    self.visit.cmrecipes=[];
                    self.visit.cmdrugs=[];
                    e.drugs.forEach(function (n) {
                      self.drugs.push(Object.assign(n, {msgs:[], errored:false}));
                      self.visit.cmrecipes.push(Object.assign(n, {msgs:[], errored:false}));
                      self.visit.cmdrugs.push(n);
                    });
                    self.visit.form.setFieldsValue({'doses': (e.doses||1), 'cmusage':e.usage, 'cmadvice':e.advice});
                    self.gestateChangeAction();//孕妇禁忌
                    self.conflictDrugs();//反畏效验
                    self.dosesChangeAction();//有毒
                    self.convertVerifyAction();//验证是否可剂型转换
                  }
                  if(e.type == 'CPM'){
                    e.drugs.forEach(function (n) {
                      self.drugs.push(Object.assign(n, {msgs:[], errored:false}));
                    });
                    self.visit.cpmrecipes=e.drugs;
                    self.visit.form.setFieldsValue({'cpmdays': (e.days||1), 'cpmusage':e.usage, 'cpmadvice':e.advice});
                  }
                  if(e.type == 'WM'){
                    e.drugs.forEach(function (n) {
                      self.drugs.push(Object.assign(n, {msgs:[], errored:false}));
                    });
                    self.visit.wmrecipes=e.drugs;
                    self.visit.form.setFieldsValue({'wmdays': (e.days||1), 'wmusage':e.usage, 'wmadvice':e.advice});
                  }
                  self.appendRecipeDrug();
                });
              }
              if(undefined != res.biz.pres && null != res.biz.pres){
                self.init.presaged=false;
                self.loading = true;
                self.loadTip='正在加载方剂信息....';
                if(res.biz.pres.type =='ENCYCLOPEDIA'){
                  self.$axios.get('/api/clinic/' + self.current.organId + '/encyc/'+res.biz.pres.oid).then(function (rs) {
                    self.loading = false;
                    if (rs.msg.flag == 0 && undefined != rs.biz && null != rs.biz) {
                      self.init.presaged=true;
                      self.init.pres ={id:rs.biz.id, type:'ENCYCLOPEDIA', name:rs.biz.name, experience:rs.biz.experience, appreciate:rs.biz.appreciate};
                      self.complements = [];
                      (res.biz.expands||[]).forEach(function (e) {
                        self.complements.push({desc:e});
                      });
                    }
                  }, function (res) {
                    self.loading = false;
                  });
                }else{
                  self.$axios.get('/api/clinic/' + self.current.organId + '/pres/'+res.biz.pres.oid).then(function (rs) {
                    self.loading = false;
                    if (rs.msg.flag == 0 && undefined != rs.biz && null != rs.biz) {
                      self.init.presaged=true;
                      self.init.pres ={id:rs.biz.id, type:rs.biz.type, name:rs.biz.name, experience:rs.biz.experience, appreciate:rs.biz.appreciate};
                      self.complements=rs.biz.complements||[];
                    }
                  }, function (res) {
                    self.loading = false;
                  });
                }
              }
            }
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        }, function (res) {
          self.loading=false;
        });
      }


    },
    presOpenAction:function (opened) {
      this.init.presopened = opened;
    },
    descTypeChange:function (type) {
      this.init.descType = type;
    },
    //显示药品信息
    drugModalAction:function (id){
      if((id||'') != ''){
        this.$refs.drugModal.showDrugModal(id);
      }
    },
    checkCustomRow:function (record, index){
      const self= this;
      let props ={};
      if((record.errored||false)){
        if(index % 2 === 1){
          props = { color: 'red', backgroundColor:'rgba(99, 171, 205, 0.06)', cursor: 'pointer' };
        }else{
          props = { color: 'red', cursor: 'pointer' };
        }
      }else{
        if(index % 2 === 1){
          props = { color: 'rgba(0, 0, 0, 0.65)',backgroundColor:'rgba(99, 171, 205, 0.06)', cursor: 'pointer' };
        }else{
          props = { color: 'rgba(0, 0, 0, 0.65)', cursor: 'pointer' };
        }
      }
      return {
        style:props,
        on:{
          dblclick: (event) => {
            self.drugModalAction(record.id);
          }
        }
      };
    },
    onBlurIdcard:function (){
      let idcard = this.visit.form.getFieldValue('idcard');
      if(undefined != idcard && null != idcard && '' != idcard && (idcard.length == 18 || idcard.length == 15)){
        idcard = idcard.trim();
        let birthday = '';
        let sex='';
        if (idcard.length == 18){
          birthday = idcard.substr(6, 4) + "/" + idcard.substr(10, 2) + "/" + idcard.substr(12, 2);
          if(parseInt(idcard.charAt(16))%2 == 0){
            sex ='FEMALE';
          }else{
            sex ='MALE';
          }
        }
        if (idcard.length == 15) {
          birthday = "19" + idcard.substr(6, 2) + "/" + idcard.substr(8, 2) + "/" + idcard.substr(10, 2);
          if(parseInt(idcard.charAt(14))%2 == 0){
            sex ='FEMALE';
          }else{
            sex ='MALE';
          }
        }
        let birthDate = new Date(birthday);
        let nowDateTime = new Date();
        let age = nowDateTime.getFullYear() - birthDate.getFullYear();

        this.visit.form.setFieldsValue({'year':age, 'sex':sex});
        this.gestateAgeMonthChange();
      }
    },
    convertVerifyAction:function (){
      let items = (this.visit.cmdrugs||[]).filter(m => (m.insteads||[]).length > 0);
      if((items||[]).length === (this.visit.cmdrugs||[]).length){
        this.converted = true;
      }else{
        this.converted = false;
      }
    },
    convertAction:function (form){
      const self = this;
      let items = (this.visit.cmdrugs||[]).filter(m => (m.insteads||[]).length > 0);
      if((items||[]).length != (this.visit.cmdrugs||[]).length){
        this.converted = false;
      }
      if(form === 'PIECES'){
        this.column.cm = [{title: '序号', key: 'cmindex', align: 'center', width: 60, scopedSlots: { customRender: 'cmindex' }},
          {title: '药名', key: 'cmdrug', align: 'center', width: 200, scopedSlots: { customRender: 'cmdrug' }},
          {title: '剂型', key: 'cmform', align: 'center', width: 80, scopedSlots: { customRender: 'cmform' }},
          {title: '用量', key: 'cmdosage', align: 'center', width: 100, scopedSlots: { customRender: 'cmdosage' }},
          {title: '单位', key: 'cmunit', align: 'center', width: 120, scopedSlots: { customRender: 'cmunit' }},
          {title: '常用剂量', key: 'cmrecommend', align: 'center', width: 120, scopedSlots: { customRender: 'cmrecommend' }},
          {title: '备注', key: 'cmusage', scopedSlots: { customRender: 'cmusage' }},
          {title: '操作', key: 'cmoperate', align: 'center', width: 80, scopedSlots: { customRender: 'cmoperate' }}];
      }else{
        this.column.cm = [{title: '序号', key: 'cmindex', align: 'center', width: 60, scopedSlots: { customRender: 'cmindex' }},
          {title: '药名', key: 'cmdrug', align: 'center', width: 200, scopedSlots: { customRender: 'cmdrug' }},
          {title: '剂型', key: 'cmform', align: 'center', width: 80, scopedSlots: { customRender: 'cmform' }},
          {title: '袋数', key: 'cmdosage', align: 'center', width: 100, scopedSlots: { customRender: 'cmdosage' }},
          {title: '用量', key: 'cmweight', align: 'center', width: 70, scopedSlots: { customRender: 'cmweight' }},
          {title: '单位', key: 'cmunit', align: 'center', width: 120, scopedSlots: { customRender: 'cmunit' }},
          {title: '常用剂量', key: 'cmrecommend', align: 'center', width: 120, scopedSlots: { customRender: 'cmrecommend' }},
          {title: '备注', key: 'cmusage', scopedSlots: { customRender: 'cmusage' }},
          {title: '操作', key: 'cmoperate', align: 'center', width: 80, scopedSlots: { customRender: 'cmoperate' }}];
      }
      this.drugs=[];
      if(undefined != this.visit.cmrecipes && null != this.visit.cmrecipes && this.visit.cmrecipes.length > 0) {
        this.visit.cmrecipes = this.visit.cmrecipes.filter(e => (undefined != e.id && null != e.id && '' != e.id));
      }
      if(undefined != this.visit.cmrecipes && null != this.visit.cmrecipes && this.visit.cmrecipes.length > 0){
        if(form === 'PIECES') {
          this.visit.cmrecipes.forEach(function (e, i) {
            if((self.visit.cmdrugs||[]).filter(m => m.id === e.sourceId).length > 0){
              let drug = (self.visit.cmdrugs||[]).filter(m => m.id === e.sourceId)[0];
              if(undefined === drug || null === drug){
                self.$message.error({content:'药品[' +e.name+ ']剂型转换时,转换药品信息为空.', duration:2 });
                return;
              }
              self.visit.cmrecipes.splice(i, 1, Object.assign(drug, {dosage:e.weight, msgs:[], errored:false}));
              self.drugs.push(Object.assign(drug, {msgs:[], errored:false}));
            }else{
              self.$message.error({content:'药品[' +e.name+ ']剂型[颗粒转饮片]时,药品信息未找到.', duration:2 });
              return;
            }
          });
        }else{
          this.visit.cmrecipes.forEach(function (e, i) {
            if(((self.visit.cmdrugs||[]).filter(m => m.id === e.id).length > 0)){
              if((((self.visit.cmdrugs||[]).filter(m => m.id === e.id)[0]).insteads||[]).length > 0
                  && (((self.visit.cmdrugs||[]).filter(m => m.id === e.id)[0]).insteads||[]).filter(n => (n.form === form)).length > 0) {
                let drug = (((self.visit.cmdrugs||[]).filter(m => m.id === e.id)[0]).insteads||[]).filter(n => (n.form === form))[0];
                let drugs=[];
                if((((self.visit.cmdrugs||[]).filter(m => m.id === e.id)[0]).insteads||[]).filter(n => (n.form === form)).length > 1){
                  (((self.visit.cmdrugs||[]).filter(m => m.id === e.id)[0]).insteads||[]).filter(n => (n.form === form)).forEach(function (it) {
                    drugs.push(it);
                  });
                }
                if(undefined === drug || null === drug){
                  self.$message.error({content:'药品[' +e.name+ ']剂型[饮片转颗粒]时,转换药品信息为空.', duration:2 });
                  return;
                }
                if(undefined === drug.sourceUnit || null === drug.sourceUnit){
                  self.$message.error({content:'药品[' +e.name+ ']剂型[饮片转颗粒]时,饮片药品转换单位为空.', duration:2 });
                  return;
                }
                if((drug.sourceUnit.name||'') != e.unit){
                  self.$message.error({content:'药品[' +e.name+ ']剂型[饮片转颗粒]时,饮片药品转换单位不一致.', duration:2 });
                  return;
                }
                if(undefined === drug.targetUnit || null === drug.targetUnit){
                  self.$message.error({content:'药品[' +e.name+ ']剂型[饮片转颗粒]时,颗粒药品转换单位为空.', duration:2 });
                  return;
                }
                let dosage = null;
                if('PIECES' === form){
                  dosage = (parseFloat(e.dosage) / parseFloat(drug.sourceQty) * parseFloat(drug.targetQty)).toFixed(2);
                }else{
                  dosage =Math.ceil(parseFloat(e.dosage) / parseFloat(drug.sourceQty) * parseFloat(drug.targetQty));
                }
                self.visit.cmrecipes.splice(i, 1, Object.assign(drug, {sourceId:e.id, recommend:e.recommend,
                  weight:e.dosage, piecesUnit:e.unit, unit:(drug.targetUnit.name||''), drugs:drugs, dosage:dosage, msgs:[], errored:false}));
                self.drugs.push(Object.assign(drug, {msgs:[], errored:false}));
              }else{
                self.$message.error({content:'药品[' +e.name+ ']剂型[饮片转颗粒]时,转换颗粒药品未配置.', duration:2 });
                return;
              }
            }else{
              self.$message.error({content:'药品[' +e.name+ ']剂型[饮片转颗粒]时,药品信息未找到.', duration:2 });
              return;
            }
          });
        }
      }
      this.appendRecipeDrug();
    },
    parseRecipe:function (drugs, desc) {
      let result = desc;
      let tags=[];
      (drugs||[]).forEach(function (item, index) {
        result = result.replace(item.name, '{'+index+'}');
        tags.push('<label style="color: #1890ff;cursor: pointer;" onclick="drugModalAction(\'' + item.id + '\')">' + item.name + '</label>');
      });

      if((tags||[]).length > 0){
        result = this.formatString(result, tags);
      }

      return result;
    }
  }
}
</script>

<style scoped>
.gpws-m-b-10 {
  margin-bottom: 2px!important;
}
.gpws-m-t-10 {
  margin-top: 2px!important;
}

.gpws-m-t-16 {
  margin-bottom: 16px!important;
}
.gpws-m-b-2 {
  margin-bottom: 2px!important;
}
.gpws-settle {
  margin-bottom: 2px!important;
}
.gpws-settle > .ant-col > .ant-form-item-control {
  line-height: 60px!important;
}
.gpws-m-b-0 {
  margin-bottom: 0px!important;
}
.gpws-visit-btn-container {
  padding: 10px 96px!important;
  background-color: #fff!important;
}

.gpws-recipe-left-active {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-left-radius: 18px!important;
  border-bottom-left-radius: 18px!important;
  color: white;
}

.gpws-recipe-right-active {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-right-radius: 18px!important;
  border-bottom-right-radius: 18px!important;
  color: white;
}
.gpws-recipe-left-btn {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-left-radius: 18px!important;
  border-bottom-left-radius: 18px!important;
}
.gpws-recipe-right-btn {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-right-radius: 18px!important;
  border-bottom-right-radius: 18px!important;
}
.gpws-recipe-active {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  color: white;
}
.gpws-recipe-btn {
  width: 120px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
}
.gpws-visit-btn {
  float: right;
  line-height: 36px;
  height: 36px;
  border-radius: 28px;
  width: 150px;
  font-size: 14px;
  font-weight: bold;
  color: white;
}

.gpws-recipe-table {
  min-height:250px!important;
  padding-top: 0px!important;
  padding-bottom: 12px!important;
  padding-left: 0px!important;
  padding-right: 0px!important;
}


.gpws-desc-left-active {
  width: 120px;
  height: 30px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-left-radius: 15px!important;
  border-bottom-left-radius: 15px!important;
  color: white;
}

.gpws-desc-right-active {
  width: 120px;
  height: 30px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-right-radius: 15px!important;
  border-bottom-right-radius: 15px!important;
  color: white;
}
.gpws-desc-left-btn {
  width: 120px;
  height: 30px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-left-radius: 15px!important;
  border-bottom-left-radius: 15px!important;
}
.gpws-desc-right-btn {
  width: 120px;
  height: 30px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-right-radius: 15px!important;
  border-bottom-right-radius: 15px!important;
}
.gpws-desc-active {
  width: 120px;
  height: 30px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  color: white;
}
.gpws-desc-btn {
  width: 120px;
  height: 30px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
}
</style>
